// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: models/fabric.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "models";

/** AdjacencyProtocol defines an enumeration of port adjacency protocols. */
export enum AdjacencyProtocol {
  /** ADJACENCY_UNSPECIFIED - Unspecified adjacency protocol type. */
  ADJACENCY_UNSPECIFIED = 0,
  /** LLDP - Link layer discovery protocol. */
  LLDP = 1,
  /** CDP - Cisco discovery protocol. */
  CDP = 2,
  /** LACP - Link aggregation control protocol (aka PortChannel). */
  LACP = 3,
  /** STP - Spanning tree protocol. */
  STP = 4,
  UNRECOGNIZED = -1,
}

export function adjacencyProtocolFromJSON(object: any): AdjacencyProtocol {
  switch (object) {
    case 0:
    case "ADJACENCY_UNSPECIFIED":
      return AdjacencyProtocol.ADJACENCY_UNSPECIFIED;
    case 1:
    case "LLDP":
      return AdjacencyProtocol.LLDP;
    case 2:
    case "CDP":
      return AdjacencyProtocol.CDP;
    case 3:
    case "LACP":
      return AdjacencyProtocol.LACP;
    case 4:
    case "STP":
      return AdjacencyProtocol.STP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AdjacencyProtocol.UNRECOGNIZED;
  }
}

export function adjacencyProtocolToJSON(object: AdjacencyProtocol): string {
  switch (object) {
    case AdjacencyProtocol.ADJACENCY_UNSPECIFIED:
      return "ADJACENCY_UNSPECIFIED";
    case AdjacencyProtocol.LLDP:
      return "LLDP";
    case AdjacencyProtocol.CDP:
      return "CDP";
    case AdjacencyProtocol.LACP:
      return "LACP";
    case AdjacencyProtocol.STP:
      return "STP";
    case AdjacencyProtocol.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Airflow defines an enumeration of types of fan airflows. */
export enum AirflowType {
  /** AIRFLOW_TYPE_UNSPECIFIED - Unspecified airflow type. */
  AIRFLOW_TYPE_UNSPECIFIED = 0,
  /** AIRFLOW_TYPE_PORT_SIDE_INTAKE - The Airflow type is Port side Intake or front-to-back. */
  AIRFLOW_TYPE_PORT_SIDE_INTAKE = 1,
  /** AIRFLOW_TYPE_PORT_SIDE_EXHAUST - The Airflow type is Port side Exhaust or back-to-front. */
  AIRFLOW_TYPE_PORT_SIDE_EXHAUST = 2,
  UNRECOGNIZED = -1,
}

export function airflowTypeFromJSON(object: any): AirflowType {
  switch (object) {
    case 0:
    case "AIRFLOW_TYPE_UNSPECIFIED":
      return AirflowType.AIRFLOW_TYPE_UNSPECIFIED;
    case 1:
    case "AIRFLOW_TYPE_PORT_SIDE_INTAKE":
      return AirflowType.AIRFLOW_TYPE_PORT_SIDE_INTAKE;
    case 2:
    case "AIRFLOW_TYPE_PORT_SIDE_EXHAUST":
      return AirflowType.AIRFLOW_TYPE_PORT_SIDE_EXHAUST;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AirflowType.UNRECOGNIZED;
  }
}

export function airflowTypeToJSON(object: AirflowType): string {
  switch (object) {
    case AirflowType.AIRFLOW_TYPE_UNSPECIFIED:
      return "AIRFLOW_TYPE_UNSPECIFIED";
    case AirflowType.AIRFLOW_TYPE_PORT_SIDE_INTAKE:
      return "AIRFLOW_TYPE_PORT_SIDE_INTAKE";
    case AirflowType.AIRFLOW_TYPE_PORT_SIDE_EXHAUST:
      return "AIRFLOW_TYPE_PORT_SIDE_EXHAUST";
    case AirflowType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** BgpPeerType enumerates types of BGP peers. */
export enum BgpPeerType {
  /** BGP_PEER_UNSPECIFIED - Unspecified BGP peer type. */
  BGP_PEER_UNSPECIFIED = 0,
  /** BGP_PEER_FABRIC_NORTHBOUND - Northbound fabric BGP peer. */
  BGP_PEER_FABRIC_NORTHBOUND = 1,
  /** BGP_PEER_FABRIC_SOUTHBOUND - Southbound fabric BGP peer. */
  BGP_PEER_FABRIC_SOUTHBOUND = 2,
  /** BGP_PEER_MULTISITE_UNDERLAY - Multisite underlay BGP peer. */
  BGP_PEER_MULTISITE_UNDERLAY = 3,
  /** BGP_PEER_MULTISITE_NORTHBOUND - Multisite northbound BGP peer. */
  BGP_PEER_MULTISITE_NORTHBOUND = 4,
  UNRECOGNIZED = -1,
}

export function bgpPeerTypeFromJSON(object: any): BgpPeerType {
  switch (object) {
    case 0:
    case "BGP_PEER_UNSPECIFIED":
      return BgpPeerType.BGP_PEER_UNSPECIFIED;
    case 1:
    case "BGP_PEER_FABRIC_NORTHBOUND":
      return BgpPeerType.BGP_PEER_FABRIC_NORTHBOUND;
    case 2:
    case "BGP_PEER_FABRIC_SOUTHBOUND":
      return BgpPeerType.BGP_PEER_FABRIC_SOUTHBOUND;
    case 3:
    case "BGP_PEER_MULTISITE_UNDERLAY":
      return BgpPeerType.BGP_PEER_MULTISITE_UNDERLAY;
    case 4:
    case "BGP_PEER_MULTISITE_NORTHBOUND":
      return BgpPeerType.BGP_PEER_MULTISITE_NORTHBOUND;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BgpPeerType.UNRECOGNIZED;
  }
}

export function bgpPeerTypeToJSON(object: BgpPeerType): string {
  switch (object) {
    case BgpPeerType.BGP_PEER_UNSPECIFIED:
      return "BGP_PEER_UNSPECIFIED";
    case BgpPeerType.BGP_PEER_FABRIC_NORTHBOUND:
      return "BGP_PEER_FABRIC_NORTHBOUND";
    case BgpPeerType.BGP_PEER_FABRIC_SOUTHBOUND:
      return "BGP_PEER_FABRIC_SOUTHBOUND";
    case BgpPeerType.BGP_PEER_MULTISITE_UNDERLAY:
      return "BGP_PEER_MULTISITE_UNDERLAY";
    case BgpPeerType.BGP_PEER_MULTISITE_NORTHBOUND:
      return "BGP_PEER_MULTISITE_NORTHBOUND";
    case BgpPeerType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** BgpPolicyType enumerates categories of BGP policies. */
export enum BgpPolicyType {
  /** BGP_POLICY_UNSPECIFIED - Unspecified BGP policy type. */
  BGP_POLICY_UNSPECIFIED = 0,
  /** BGP_POLICY_STANDARD - BGP policy used for standard BGP peering. */
  BGP_POLICY_STANDARD = 1,
  /** BGP_POLICY_MULTISITE_UNDERLAY - BGP policy used for multisite underlay peering. */
  BGP_POLICY_MULTISITE_UNDERLAY = 2,
  /** BGP_POLICY_MULTISITE_OVERLAY - BGP policy used for multisite overlay peering. */
  BGP_POLICY_MULTISITE_OVERLAY = 3,
  UNRECOGNIZED = -1,
}

export function bgpPolicyTypeFromJSON(object: any): BgpPolicyType {
  switch (object) {
    case 0:
    case "BGP_POLICY_UNSPECIFIED":
      return BgpPolicyType.BGP_POLICY_UNSPECIFIED;
    case 1:
    case "BGP_POLICY_STANDARD":
      return BgpPolicyType.BGP_POLICY_STANDARD;
    case 2:
    case "BGP_POLICY_MULTISITE_UNDERLAY":
      return BgpPolicyType.BGP_POLICY_MULTISITE_UNDERLAY;
    case 3:
    case "BGP_POLICY_MULTISITE_OVERLAY":
      return BgpPolicyType.BGP_POLICY_MULTISITE_OVERLAY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BgpPolicyType.UNRECOGNIZED;
  }
}

export function bgpPolicyTypeToJSON(object: BgpPolicyType): string {
  switch (object) {
    case BgpPolicyType.BGP_POLICY_UNSPECIFIED:
      return "BGP_POLICY_UNSPECIFIED";
    case BgpPolicyType.BGP_POLICY_STANDARD:
      return "BGP_POLICY_STANDARD";
    case BgpPolicyType.BGP_POLICY_MULTISITE_UNDERLAY:
      return "BGP_POLICY_MULTISITE_UNDERLAY";
    case BgpPolicyType.BGP_POLICY_MULTISITE_OVERLAY:
      return "BGP_POLICY_MULTISITE_OVERLAY";
    case BgpPolicyType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** BomType encapsulates type of a Bom Item. */
export enum BomType {
  /** BOM_TYPE_UNSPECIFIED - Unspecified Bom type. */
  BOM_TYPE_UNSPECIFIED = 0,
  /** BOM_TYPE_HARDWARE - Hardware ATO. */
  BOM_TYPE_HARDWARE = 1,
  /** BOM_TYPE_SERVICE - Subscription service ATO. */
  BOM_TYPE_SERVICE = 2,
  /** BOM_TYPE_CHASSIS - Hardware chassis. */
  BOM_TYPE_CHASSIS = 3,
  /** BOM_TYPE_OPTICS - Optics pluggable. */
  BOM_TYPE_OPTICS = 4,
  /** BOM_TYPE_FAN - Fan type. */
  BOM_TYPE_FAN = 5,
  /** BOM_TYPE_PSU - Power supply Unit. */
  BOM_TYPE_PSU = 6,
  /** BOM_TYPE_ENTITLEMENT - Entitlement tier. */
  BOM_TYPE_ENTITLEMENT = 7,
  /** BOM_TYPE_MLB - Major Line Bundle. */
  BOM_TYPE_MLB = 8,
  /** BOM_TYPE_CABLE - Cable type. */
  BOM_TYPE_CABLE = 9,
  /** BOM_TYPE_AIRFLOW - Airflow type. */
  BOM_TYPE_AIRFLOW = 10,
  /** BOM_TYPE_OTHER - Other miscellaneous types. */
  BOM_TYPE_OTHER = 20,
  UNRECOGNIZED = -1,
}

export function bomTypeFromJSON(object: any): BomType {
  switch (object) {
    case 0:
    case "BOM_TYPE_UNSPECIFIED":
      return BomType.BOM_TYPE_UNSPECIFIED;
    case 1:
    case "BOM_TYPE_HARDWARE":
      return BomType.BOM_TYPE_HARDWARE;
    case 2:
    case "BOM_TYPE_SERVICE":
      return BomType.BOM_TYPE_SERVICE;
    case 3:
    case "BOM_TYPE_CHASSIS":
      return BomType.BOM_TYPE_CHASSIS;
    case 4:
    case "BOM_TYPE_OPTICS":
      return BomType.BOM_TYPE_OPTICS;
    case 5:
    case "BOM_TYPE_FAN":
      return BomType.BOM_TYPE_FAN;
    case 6:
    case "BOM_TYPE_PSU":
      return BomType.BOM_TYPE_PSU;
    case 7:
    case "BOM_TYPE_ENTITLEMENT":
      return BomType.BOM_TYPE_ENTITLEMENT;
    case 8:
    case "BOM_TYPE_MLB":
      return BomType.BOM_TYPE_MLB;
    case 9:
    case "BOM_TYPE_CABLE":
      return BomType.BOM_TYPE_CABLE;
    case 10:
    case "BOM_TYPE_AIRFLOW":
      return BomType.BOM_TYPE_AIRFLOW;
    case 20:
    case "BOM_TYPE_OTHER":
      return BomType.BOM_TYPE_OTHER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BomType.UNRECOGNIZED;
  }
}

export function bomTypeToJSON(object: BomType): string {
  switch (object) {
    case BomType.BOM_TYPE_UNSPECIFIED:
      return "BOM_TYPE_UNSPECIFIED";
    case BomType.BOM_TYPE_HARDWARE:
      return "BOM_TYPE_HARDWARE";
    case BomType.BOM_TYPE_SERVICE:
      return "BOM_TYPE_SERVICE";
    case BomType.BOM_TYPE_CHASSIS:
      return "BOM_TYPE_CHASSIS";
    case BomType.BOM_TYPE_OPTICS:
      return "BOM_TYPE_OPTICS";
    case BomType.BOM_TYPE_FAN:
      return "BOM_TYPE_FAN";
    case BomType.BOM_TYPE_PSU:
      return "BOM_TYPE_PSU";
    case BomType.BOM_TYPE_ENTITLEMENT:
      return "BOM_TYPE_ENTITLEMENT";
    case BomType.BOM_TYPE_MLB:
      return "BOM_TYPE_MLB";
    case BomType.BOM_TYPE_CABLE:
      return "BOM_TYPE_CABLE";
    case BomType.BOM_TYPE_AIRFLOW:
      return "BOM_TYPE_AIRFLOW";
    case BomType.BOM_TYPE_OTHER:
      return "BOM_TYPE_OTHER";
    case BomType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** CableType defines an enumeration of cable types. */
export enum CableType {
  /** CABLE_TYPE_UNSPECIFIED - Unspecified cable type. */
  CABLE_TYPE_UNSPECIFIED = 0,
  /** DAC - Directly attached copper cable. */
  DAC = 1,
  /** FIBER - Fiber or optics cable type. */
  FIBER = 2,
  /** AOC - Active Optical Cable. */
  AOC = 3,
  /** SMF - Single-Mode Fiber. */
  SMF = 4,
  /** MMF - Multi-Mode Fiber. */
  MMF = 5,
  /** CAT6AOR7 - Copper cable of type Cat6a or Cat7. */
  CAT6AOR7 = 6,
  /** CAT5E - Copper cable of type Cat5e */
  CAT5E = 7,
  UNRECOGNIZED = -1,
}

export function cableTypeFromJSON(object: any): CableType {
  switch (object) {
    case 0:
    case "CABLE_TYPE_UNSPECIFIED":
      return CableType.CABLE_TYPE_UNSPECIFIED;
    case 1:
    case "DAC":
      return CableType.DAC;
    case 2:
    case "FIBER":
      return CableType.FIBER;
    case 3:
    case "AOC":
      return CableType.AOC;
    case 4:
    case "SMF":
      return CableType.SMF;
    case 5:
    case "MMF":
      return CableType.MMF;
    case 6:
    case "CAT6AOR7":
      return CableType.CAT6AOR7;
    case 7:
    case "CAT5E":
      return CableType.CAT5E;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CableType.UNRECOGNIZED;
  }
}

export function cableTypeToJSON(object: CableType): string {
  switch (object) {
    case CableType.CABLE_TYPE_UNSPECIFIED:
      return "CABLE_TYPE_UNSPECIFIED";
    case CableType.DAC:
      return "DAC";
    case CableType.FIBER:
      return "FIBER";
    case CableType.AOC:
      return "AOC";
    case CableType.SMF:
      return "SMF";
    case CableType.MMF:
      return "MMF";
    case CableType.CAT6AOR7:
      return "CAT6AOR7";
    case CableType.CAT5E:
      return "CAT5E";
    case CableType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * CablingStrategy defines the mode in which ports are chosen to satisfy the connectivity rules between
 * two topology groups
 */
export enum CablingStrategy {
  CABLING_STRATEGY_UNSPECIFIED = 0,
  STRICT_DENSE = 1,
  BEST_EFFORT_DENSE = 2,
  STRICT_DISTRIBUTED = 3,
  BEST_EFFORT_DISTRIBUTED = 4,
  FIRST_AVAILABLE = 5,
  SERVER_DISTRIBUTED = 6,
  UNRECOGNIZED = -1,
}

export function cablingStrategyFromJSON(object: any): CablingStrategy {
  switch (object) {
    case 0:
    case "CABLING_STRATEGY_UNSPECIFIED":
      return CablingStrategy.CABLING_STRATEGY_UNSPECIFIED;
    case 1:
    case "STRICT_DENSE":
      return CablingStrategy.STRICT_DENSE;
    case 2:
    case "BEST_EFFORT_DENSE":
      return CablingStrategy.BEST_EFFORT_DENSE;
    case 3:
    case "STRICT_DISTRIBUTED":
      return CablingStrategy.STRICT_DISTRIBUTED;
    case 4:
    case "BEST_EFFORT_DISTRIBUTED":
      return CablingStrategy.BEST_EFFORT_DISTRIBUTED;
    case 5:
    case "FIRST_AVAILABLE":
      return CablingStrategy.FIRST_AVAILABLE;
    case 6:
    case "SERVER_DISTRIBUTED":
      return CablingStrategy.SERVER_DISTRIBUTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CablingStrategy.UNRECOGNIZED;
  }
}

export function cablingStrategyToJSON(object: CablingStrategy): string {
  switch (object) {
    case CablingStrategy.CABLING_STRATEGY_UNSPECIFIED:
      return "CABLING_STRATEGY_UNSPECIFIED";
    case CablingStrategy.STRICT_DENSE:
      return "STRICT_DENSE";
    case CablingStrategy.BEST_EFFORT_DENSE:
      return "BEST_EFFORT_DENSE";
    case CablingStrategy.STRICT_DISTRIBUTED:
      return "STRICT_DISTRIBUTED";
    case CablingStrategy.BEST_EFFORT_DISTRIBUTED:
      return "BEST_EFFORT_DISTRIBUTED";
    case CablingStrategy.FIRST_AVAILABLE:
      return "FIRST_AVAILABLE";
    case CablingStrategy.SERVER_DISTRIBUTED:
      return "SERVER_DISTRIBUTED";
    case CablingStrategy.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** CandidateType defines an enumeration of candidate types. */
export enum CandidateType {
  /** CANDIDATE_UNSPECIFIED - Unspecified candidate type. */
  CANDIDATE_UNSPECIFIED = 0,
  /**
   * CANDIDATE_CONFIGS - The candidate contains config changes. A CONFIGS candidate will not contain requests that are only permitted
   * in the CANDIDATE_MAINTENANCE_ON candidate.
   */
  CANDIDATE_CONFIGS = 1,
  /**
   * CANDIDATE_MAINTENANCE_ON - The candidate contains the configurations that are only permitted in a MAINTENANCE_ON candidate, including
   * changing the SoftwareMode to maintenance and assigning node images.
   * A MAINTENANCE_ON candidate will not contain requests are only permitted in the CONFIGS candidate.
   */
  CANDIDATE_MAINTENANCE_ON = 2,
  /**
   * CANDIDATE_MAINTENANCE_OFF - The candidate contains the configurations that will turn off the maintenance mode, including changing the
   * SoftwareMode to MAINTENANCE_OFF, and deleting the node image assignment.
   */
  CANDIDATE_MAINTENANCE_OFF = 3,
  /** CANDIDATE_NEUTRAL - The candidate contains the configurations that are permitted in all candidate types. */
  CANDIDATE_NEUTRAL = 4,
  UNRECOGNIZED = -1,
}

export function candidateTypeFromJSON(object: any): CandidateType {
  switch (object) {
    case 0:
    case "CANDIDATE_UNSPECIFIED":
      return CandidateType.CANDIDATE_UNSPECIFIED;
    case 1:
    case "CANDIDATE_CONFIGS":
      return CandidateType.CANDIDATE_CONFIGS;
    case 2:
    case "CANDIDATE_MAINTENANCE_ON":
      return CandidateType.CANDIDATE_MAINTENANCE_ON;
    case 3:
    case "CANDIDATE_MAINTENANCE_OFF":
      return CandidateType.CANDIDATE_MAINTENANCE_OFF;
    case 4:
    case "CANDIDATE_NEUTRAL":
      return CandidateType.CANDIDATE_NEUTRAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CandidateType.UNRECOGNIZED;
  }
}

export function candidateTypeToJSON(object: CandidateType): string {
  switch (object) {
    case CandidateType.CANDIDATE_UNSPECIFIED:
      return "CANDIDATE_UNSPECIFIED";
    case CandidateType.CANDIDATE_CONFIGS:
      return "CANDIDATE_CONFIGS";
    case CandidateType.CANDIDATE_MAINTENANCE_ON:
      return "CANDIDATE_MAINTENANCE_ON";
    case CandidateType.CANDIDATE_MAINTENANCE_OFF:
      return "CANDIDATE_MAINTENANCE_OFF";
    case CandidateType.CANDIDATE_NEUTRAL:
      return "CANDIDATE_NEUTRAL";
    case CandidateType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * ConfigOrigin is used by a management port to indicate if the configuration
 * was provided by the cloud or the device.
 */
export enum ConfigOrigin {
  /** CONFIG_ORIGIN_UNSPECIFIED - Unspecified config origin. */
  CONFIG_ORIGIN_UNSPECIFIED = 0,
  /** CONFIG_ORIGIN_CLOUD - The management port configuration has been provided by the user. */
  CONFIG_ORIGIN_CLOUD = 1,
  /** CONFIG_ORIGIN_DEVICE - The management port configuration was determined by the device. */
  CONFIG_ORIGIN_DEVICE = 2,
  UNRECOGNIZED = -1,
}

export function configOriginFromJSON(object: any): ConfigOrigin {
  switch (object) {
    case 0:
    case "CONFIG_ORIGIN_UNSPECIFIED":
      return ConfigOrigin.CONFIG_ORIGIN_UNSPECIFIED;
    case 1:
    case "CONFIG_ORIGIN_CLOUD":
      return ConfigOrigin.CONFIG_ORIGIN_CLOUD;
    case 2:
    case "CONFIG_ORIGIN_DEVICE":
      return ConfigOrigin.CONFIG_ORIGIN_DEVICE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ConfigOrigin.UNRECOGNIZED;
  }
}

export function configOriginToJSON(object: ConfigOrigin): string {
  switch (object) {
    case ConfigOrigin.CONFIG_ORIGIN_UNSPECIFIED:
      return "CONFIG_ORIGIN_UNSPECIFIED";
    case ConfigOrigin.CONFIG_ORIGIN_CLOUD:
      return "CONFIG_ORIGIN_CLOUD";
    case ConfigOrigin.CONFIG_ORIGIN_DEVICE:
      return "CONFIG_ORIGIN_DEVICE";
    case ConfigOrigin.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * ConfigType is used by a management port to indicate if the IP
 * configuration is static or DHCP.
 */
export enum ConfigType {
  /** CONFIG_TYPE_UNSPECIFIED - Unspecified config origin. */
  CONFIG_TYPE_UNSPECIFIED = 0,
  /** CONFIG_TYPE_STATIC - The management port configuration has been provided by the user. */
  CONFIG_TYPE_STATIC = 1,
  /** CONFIG_TYPE_DHCP - The management port configuration has been set through DHCP. */
  CONFIG_TYPE_DHCP = 2,
  UNRECOGNIZED = -1,
}

export function configTypeFromJSON(object: any): ConfigType {
  switch (object) {
    case 0:
    case "CONFIG_TYPE_UNSPECIFIED":
      return ConfigType.CONFIG_TYPE_UNSPECIFIED;
    case 1:
    case "CONFIG_TYPE_STATIC":
      return ConfigType.CONFIG_TYPE_STATIC;
    case 2:
    case "CONFIG_TYPE_DHCP":
      return ConfigType.CONFIG_TYPE_DHCP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ConfigType.UNRECOGNIZED;
  }
}

export function configTypeToJSON(object: ConfigType): string {
  switch (object) {
    case ConfigType.CONFIG_TYPE_UNSPECIFIED:
      return "CONFIG_TYPE_UNSPECIFIED";
    case ConfigType.CONFIG_TYPE_STATIC:
      return "CONFIG_TYPE_STATIC";
    case ConfigType.CONFIG_TYPE_DHCP:
      return "CONFIG_TYPE_DHCP";
    case ConfigType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** ConnSourceType defines an enumeration of source types for a connection. */
export enum ConnSourceType {
  /** CONN_SOURCE_TYPE_UNSPECIFIED - Unspecified connection source type. */
  CONN_SOURCE_TYPE_UNSPECIFIED = 0,
  /**
   * CONN_SOURCE_USER_CONFIGURED - This is set when the connection was created by the user
   * from the fabric or switch context
   */
  CONN_SOURCE_USER_CONFIGURED = 1,
  /**
   * CONN_SOURCE_MANUAL_OVERRIDE - This is set when the connection was created by the user
   * from the fabric designer as a manual override
   */
  CONN_SOURCE_MANUAL_OVERRIDE = 2,
  /**
   * CONN_SOURCE_CABLING_PLAN - This is set when the connection was created by the cabling
   * algorithm based on the group connectivity rules in the
   * fabric design
   */
  CONN_SOURCE_CABLING_PLAN = 3,
  /**
   * CONN_SOURCE_OBSERVED_STATE - This is set when the connection was physically observed
   * and incorporated into the cabling plan if it matched the
   * group connectivity rules in the fabric design.
   */
  CONN_SOURCE_OBSERVED_STATE = 4,
  UNRECOGNIZED = -1,
}

export function connSourceTypeFromJSON(object: any): ConnSourceType {
  switch (object) {
    case 0:
    case "CONN_SOURCE_TYPE_UNSPECIFIED":
      return ConnSourceType.CONN_SOURCE_TYPE_UNSPECIFIED;
    case 1:
    case "CONN_SOURCE_USER_CONFIGURED":
      return ConnSourceType.CONN_SOURCE_USER_CONFIGURED;
    case 2:
    case "CONN_SOURCE_MANUAL_OVERRIDE":
      return ConnSourceType.CONN_SOURCE_MANUAL_OVERRIDE;
    case 3:
    case "CONN_SOURCE_CABLING_PLAN":
      return ConnSourceType.CONN_SOURCE_CABLING_PLAN;
    case 4:
    case "CONN_SOURCE_OBSERVED_STATE":
      return ConnSourceType.CONN_SOURCE_OBSERVED_STATE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ConnSourceType.UNRECOGNIZED;
  }
}

export function connSourceTypeToJSON(object: ConnSourceType): string {
  switch (object) {
    case ConnSourceType.CONN_SOURCE_TYPE_UNSPECIFIED:
      return "CONN_SOURCE_TYPE_UNSPECIFIED";
    case ConnSourceType.CONN_SOURCE_USER_CONFIGURED:
      return "CONN_SOURCE_USER_CONFIGURED";
    case ConnSourceType.CONN_SOURCE_MANUAL_OVERRIDE:
      return "CONN_SOURCE_MANUAL_OVERRIDE";
    case ConnSourceType.CONN_SOURCE_CABLING_PLAN:
      return "CONN_SOURCE_CABLING_PLAN";
    case ConnSourceType.CONN_SOURCE_OBSERVED_STATE:
      return "CONN_SOURCE_OBSERVED_STATE";
    case ConnSourceType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * ConnectedState is used by a management port to indicate if the port
 * is successfully connected to the Hyperfabric service. It is
 * distinct from the AdminState.
 */
export enum ConnectedState {
  /** CONNECTED_STATE_UNSPECIFIED - Unspecified connected state. */
  CONNECTED_STATE_UNSPECIFIED = 0,
  /** CONNECTED_STATE_NOT_CONNECTED - The management port has never connected. */
  CONNECTED_STATE_NOT_CONNECTED = 1,
  /** CONNECTED_STATE_CONNECTED - The management port is connected or has connected at some point. */
  CONNECTED_STATE_CONNECTED = 2,
  UNRECOGNIZED = -1,
}

export function connectedStateFromJSON(object: any): ConnectedState {
  switch (object) {
    case 0:
    case "CONNECTED_STATE_UNSPECIFIED":
      return ConnectedState.CONNECTED_STATE_UNSPECIFIED;
    case 1:
    case "CONNECTED_STATE_NOT_CONNECTED":
      return ConnectedState.CONNECTED_STATE_NOT_CONNECTED;
    case 2:
    case "CONNECTED_STATE_CONNECTED":
      return ConnectedState.CONNECTED_STATE_CONNECTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ConnectedState.UNRECOGNIZED;
  }
}

export function connectedStateToJSON(object: ConnectedState): string {
  switch (object) {
    case ConnectedState.CONNECTED_STATE_UNSPECIFIED:
      return "CONNECTED_STATE_UNSPECIFIED";
    case ConnectedState.CONNECTED_STATE_NOT_CONNECTED:
      return "CONNECTED_STATE_NOT_CONNECTED";
    case ConnectedState.CONNECTED_STATE_CONNECTED:
      return "CONNECTED_STATE_CONNECTED";
    case ConnectedState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** DciType enumerates types of DCI or Multisite config. */
export enum DciType {
  /** DCI_UNSPECIFIED - Unspecified DCI type. */
  DCI_UNSPECIFIED = 0,
  /** DCI_DIRECT - Direct back-to-back DCI (two fabrics). */
  DCI_DIRECT = 1,
  /** DCI_MESH - Full mesh of multiple fabrics */
  DCI_MESH = 2,
  /** DCI_HUB_SPOKE - Hub & spoke interconnect with route servers. */
  DCI_HUB_SPOKE = 3,
  UNRECOGNIZED = -1,
}

export function dciTypeFromJSON(object: any): DciType {
  switch (object) {
    case 0:
    case "DCI_UNSPECIFIED":
      return DciType.DCI_UNSPECIFIED;
    case 1:
    case "DCI_DIRECT":
      return DciType.DCI_DIRECT;
    case 2:
    case "DCI_MESH":
      return DciType.DCI_MESH;
    case 3:
    case "DCI_HUB_SPOKE":
      return DciType.DCI_HUB_SPOKE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DciType.UNRECOGNIZED;
  }
}

export function dciTypeToJSON(object: DciType): string {
  switch (object) {
    case DciType.DCI_UNSPECIFIED:
      return "DCI_UNSPECIFIED";
    case DciType.DCI_DIRECT:
      return "DCI_DIRECT";
    case DciType.DCI_MESH:
      return "DCI_MESH";
    case DciType.DCI_HUB_SPOKE:
      return "DCI_HUB_SPOKE";
    case DciType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * DeviceOrderableType encodes a restricted-support qualifier for a device
 * model.
 */
export enum DeviceOrderableType {
  /** DEVICE_ORDERABLE_TYPE_UNSPECIFIED - Unspecified Orderable type. */
  DEVICE_ORDERABLE_TYPE_UNSPECIFIED = 0,
  /**
   * DEVICE_ORDERABLE_TYPE_DESIGNER - The device model is usable in fabric design only; it is not
   * included in CCW estimates and is not bindable to a fabric node.
   */
  DEVICE_ORDERABLE_TYPE_DESIGNER = 1,
  /**
   * DEVICE_ORDERABLE_TYPE_ORDERABLE - The device model can be used in a fabric design and is included in
   * CCW estimates, but devices of this model are not yet allowed to be
   * bound to a fabric node.
   */
  DEVICE_ORDERABLE_TYPE_ORDERABLE = 2,
  /**
   * DEVICE_ORDERABLE_TYPE_BINDABLE - The device model is fully supported. Allowed in fabric design,
   * BOM/CCW estimate, and binding to a fabric node.
   */
  DEVICE_ORDERABLE_TYPE_BINDABLE = 3,
  UNRECOGNIZED = -1,
}

export function deviceOrderableTypeFromJSON(object: any): DeviceOrderableType {
  switch (object) {
    case 0:
    case "DEVICE_ORDERABLE_TYPE_UNSPECIFIED":
      return DeviceOrderableType.DEVICE_ORDERABLE_TYPE_UNSPECIFIED;
    case 1:
    case "DEVICE_ORDERABLE_TYPE_DESIGNER":
      return DeviceOrderableType.DEVICE_ORDERABLE_TYPE_DESIGNER;
    case 2:
    case "DEVICE_ORDERABLE_TYPE_ORDERABLE":
      return DeviceOrderableType.DEVICE_ORDERABLE_TYPE_ORDERABLE;
    case 3:
    case "DEVICE_ORDERABLE_TYPE_BINDABLE":
      return DeviceOrderableType.DEVICE_ORDERABLE_TYPE_BINDABLE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DeviceOrderableType.UNRECOGNIZED;
  }
}

export function deviceOrderableTypeToJSON(object: DeviceOrderableType): string {
  switch (object) {
    case DeviceOrderableType.DEVICE_ORDERABLE_TYPE_UNSPECIFIED:
      return "DEVICE_ORDERABLE_TYPE_UNSPECIFIED";
    case DeviceOrderableType.DEVICE_ORDERABLE_TYPE_DESIGNER:
      return "DEVICE_ORDERABLE_TYPE_DESIGNER";
    case DeviceOrderableType.DEVICE_ORDERABLE_TYPE_ORDERABLE:
      return "DEVICE_ORDERABLE_TYPE_ORDERABLE";
    case DeviceOrderableType.DEVICE_ORDERABLE_TYPE_BINDABLE:
      return "DEVICE_ORDERABLE_TYPE_BINDABLE";
    case DeviceOrderableType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** DirectionType enumerates various types of traffic direction. */
export enum DirectionType {
  /** DIRECTION_UNSPECIFIED - Unspecified direction type. */
  DIRECTION_UNSPECIFIED = 0,
  /** DIRECTION_RX - Receive direction type. */
  DIRECTION_RX = 1,
  /** DIRECTION_TX - Transmit direction type. */
  DIRECTION_TX = 2,
  /** DIRECTION_BOTH - Bidirectional (Rx/Tx) direction type. */
  DIRECTION_BOTH = 3,
  UNRECOGNIZED = -1,
}

export function directionTypeFromJSON(object: any): DirectionType {
  switch (object) {
    case 0:
    case "DIRECTION_UNSPECIFIED":
      return DirectionType.DIRECTION_UNSPECIFIED;
    case 1:
    case "DIRECTION_RX":
      return DirectionType.DIRECTION_RX;
    case 2:
    case "DIRECTION_TX":
      return DirectionType.DIRECTION_TX;
    case 3:
    case "DIRECTION_BOTH":
      return DirectionType.DIRECTION_BOTH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DirectionType.UNRECOGNIZED;
  }
}

export function directionTypeToJSON(object: DirectionType): string {
  switch (object) {
    case DirectionType.DIRECTION_UNSPECIFIED:
      return "DIRECTION_UNSPECIFIED";
    case DirectionType.DIRECTION_RX:
      return "DIRECTION_RX";
    case DirectionType.DIRECTION_TX:
      return "DIRECTION_TX";
    case DirectionType.DIRECTION_BOTH:
      return "DIRECTION_BOTH";
    case DirectionType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** EstimateStatus enumerates various status of estimate creation. */
export enum EstimateStatus {
  /** ESTIMATE_STATUS_UNSPECIFIED - Unspecified Estimate Status. */
  ESTIMATE_STATUS_UNSPECIFIED = 0,
  /** ESTIMATE_STATUS_COMPLETE - Estimate creation complete Status. */
  ESTIMATE_STATUS_COMPLETE = 2,
  /** ESTIMATE_STATUS_INCOMPLETE - Estimate creation Incomplete Status. */
  ESTIMATE_STATUS_INCOMPLETE = 3,
  UNRECOGNIZED = -1,
}

export function estimateStatusFromJSON(object: any): EstimateStatus {
  switch (object) {
    case 0:
    case "ESTIMATE_STATUS_UNSPECIFIED":
      return EstimateStatus.ESTIMATE_STATUS_UNSPECIFIED;
    case 2:
    case "ESTIMATE_STATUS_COMPLETE":
      return EstimateStatus.ESTIMATE_STATUS_COMPLETE;
    case 3:
    case "ESTIMATE_STATUS_INCOMPLETE":
      return EstimateStatus.ESTIMATE_STATUS_INCOMPLETE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EstimateStatus.UNRECOGNIZED;
  }
}

export function estimateStatusToJSON(object: EstimateStatus): string {
  switch (object) {
    case EstimateStatus.ESTIMATE_STATUS_UNSPECIFIED:
      return "ESTIMATE_STATUS_UNSPECIFIED";
    case EstimateStatus.ESTIMATE_STATUS_COMPLETE:
      return "ESTIMATE_STATUS_COMPLETE";
    case EstimateStatus.ESTIMATE_STATUS_INCOMPLETE:
      return "ESTIMATE_STATUS_INCOMPLETE";
    case EstimateStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** FabricTemplateType defines the type of the fabric blueprint template */
export enum FabricTemplateType {
  TEMPLATE_TYPE_UNSPECIFIED = 0,
  SWITCH_FABRIC = 1,
  AI_CLUSTER = 2,
  CUSTOM_TEMPLATE = 3,
  UNRECOGNIZED = -1,
}

export function fabricTemplateTypeFromJSON(object: any): FabricTemplateType {
  switch (object) {
    case 0:
    case "TEMPLATE_TYPE_UNSPECIFIED":
      return FabricTemplateType.TEMPLATE_TYPE_UNSPECIFIED;
    case 1:
    case "SWITCH_FABRIC":
      return FabricTemplateType.SWITCH_FABRIC;
    case 2:
    case "AI_CLUSTER":
      return FabricTemplateType.AI_CLUSTER;
    case 3:
    case "CUSTOM_TEMPLATE":
      return FabricTemplateType.CUSTOM_TEMPLATE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FabricTemplateType.UNRECOGNIZED;
  }
}

export function fabricTemplateTypeToJSON(object: FabricTemplateType): string {
  switch (object) {
    case FabricTemplateType.TEMPLATE_TYPE_UNSPECIFIED:
      return "TEMPLATE_TYPE_UNSPECIFIED";
    case FabricTemplateType.SWITCH_FABRIC:
      return "SWITCH_FABRIC";
    case FabricTemplateType.AI_CLUSTER:
      return "AI_CLUSTER";
    case FabricTemplateType.CUSTOM_TEMPLATE:
      return "CUSTOM_TEMPLATE";
    case FabricTemplateType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** FabricTopology defines an enumeration of types of fabric topologies. */
export enum FabricTopology {
  /** TOPOLOGY_UNSPECIFIED - Unspecified fabric topology. */
  TOPOLOGY_UNSPECIFIED = 0,
  /** MESH - A mesh of two or more nodes. */
  MESH = 1,
  /** SPINE_LEAF - A spine-leaf fabric topology. */
  SPINE_LEAF = 2,
  /** DESIGN_BASED - The topology is based on a design created from a template. */
  DESIGN_BASED = 3,
  UNRECOGNIZED = -1,
}

export function fabricTopologyFromJSON(object: any): FabricTopology {
  switch (object) {
    case 0:
    case "TOPOLOGY_UNSPECIFIED":
      return FabricTopology.TOPOLOGY_UNSPECIFIED;
    case 1:
    case "MESH":
      return FabricTopology.MESH;
    case 2:
    case "SPINE_LEAF":
      return FabricTopology.SPINE_LEAF;
    case 3:
    case "DESIGN_BASED":
      return FabricTopology.DESIGN_BASED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FabricTopology.UNRECOGNIZED;
  }
}

export function fabricTopologyToJSON(object: FabricTopology): string {
  switch (object) {
    case FabricTopology.TOPOLOGY_UNSPECIFIED:
      return "TOPOLOGY_UNSPECIFIED";
    case FabricTopology.MESH:
      return "MESH";
    case FabricTopology.SPINE_LEAF:
      return "SPINE_LEAF";
    case FabricTopology.DESIGN_BASED:
      return "DESIGN_BASED";
    case FabricTopology.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** GroupConnectivityRuleType specifies the type of groups referenced in the connectivity rule */
export enum GroupConnectivityRuleType {
  /** GROUP_CONNECTIVITY_RULE_TYPE_UNSPECIFIED - Unspecified connectivity rule type */
  GROUP_CONNECTIVITY_RULE_TYPE_UNSPECIFIED = 0,
  /** SWITCH_GROUP_TO_SWITCH_GROUP - connectivity rule between two switch groups */
  SWITCH_GROUP_TO_SWITCH_GROUP = 1,
  /** SERVER_GROUP_TO_SWITCH_GROUP - connectivity rule between a server group and a switch group */
  SERVER_GROUP_TO_SWITCH_GROUP = 2,
  UNRECOGNIZED = -1,
}

export function groupConnectivityRuleTypeFromJSON(object: any): GroupConnectivityRuleType {
  switch (object) {
    case 0:
    case "GROUP_CONNECTIVITY_RULE_TYPE_UNSPECIFIED":
      return GroupConnectivityRuleType.GROUP_CONNECTIVITY_RULE_TYPE_UNSPECIFIED;
    case 1:
    case "SWITCH_GROUP_TO_SWITCH_GROUP":
      return GroupConnectivityRuleType.SWITCH_GROUP_TO_SWITCH_GROUP;
    case 2:
    case "SERVER_GROUP_TO_SWITCH_GROUP":
      return GroupConnectivityRuleType.SERVER_GROUP_TO_SWITCH_GROUP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GroupConnectivityRuleType.UNRECOGNIZED;
  }
}

export function groupConnectivityRuleTypeToJSON(object: GroupConnectivityRuleType): string {
  switch (object) {
    case GroupConnectivityRuleType.GROUP_CONNECTIVITY_RULE_TYPE_UNSPECIFIED:
      return "GROUP_CONNECTIVITY_RULE_TYPE_UNSPECIFIED";
    case GroupConnectivityRuleType.SWITCH_GROUP_TO_SWITCH_GROUP:
      return "SWITCH_GROUP_TO_SWITCH_GROUP";
    case GroupConnectivityRuleType.SERVER_GROUP_TO_SWITCH_GROUP:
      return "SERVER_GROUP_TO_SWITCH_GROUP";
    case GroupConnectivityRuleType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** ImageCompatibilityType defines the image compatibility type */
export enum ImageCompatibilityType {
  /** IMAGE_COMPATIBILITY_TYPE_UNSPECIFIED - The image compatibility type is unspecified. */
  IMAGE_COMPATIBILITY_TYPE_UNSPECIFIED = 0,
  /** IMAGE_COMPATIBILITY_TYPE_SONIC_AGENT - The sonic-to-agent compatibility */
  IMAGE_COMPATIBILITY_TYPE_SONIC_AGENT = 1,
  /** IMAGE_COMPATIBILITY_TYPE_AGENT_FULL_MANIFEST - Compatible with the agent with full availability pinned in the softwareUpdate manifest */
  IMAGE_COMPATIBILITY_TYPE_AGENT_FULL_MANIFEST = 2,
  /** IMAGE_COMPATIBILITY_TYPE_AGENT_ONLY_MANIFEST - Compatible with the agent with the agent-only availability pinned in the softwareUpdate manifest */
  IMAGE_COMPATIBILITY_TYPE_AGENT_ONLY_MANIFEST = 3,
  /** IMAGE_COMPATIBILITY_TYPE_AGENT_CONTAINER_MANIFEST - Compatible with the agent_container pinned in the softwareUpdate manifest */
  IMAGE_COMPATIBILITY_TYPE_AGENT_CONTAINER_MANIFEST = 4,
  UNRECOGNIZED = -1,
}

export function imageCompatibilityTypeFromJSON(object: any): ImageCompatibilityType {
  switch (object) {
    case 0:
    case "IMAGE_COMPATIBILITY_TYPE_UNSPECIFIED":
      return ImageCompatibilityType.IMAGE_COMPATIBILITY_TYPE_UNSPECIFIED;
    case 1:
    case "IMAGE_COMPATIBILITY_TYPE_SONIC_AGENT":
      return ImageCompatibilityType.IMAGE_COMPATIBILITY_TYPE_SONIC_AGENT;
    case 2:
    case "IMAGE_COMPATIBILITY_TYPE_AGENT_FULL_MANIFEST":
      return ImageCompatibilityType.IMAGE_COMPATIBILITY_TYPE_AGENT_FULL_MANIFEST;
    case 3:
    case "IMAGE_COMPATIBILITY_TYPE_AGENT_ONLY_MANIFEST":
      return ImageCompatibilityType.IMAGE_COMPATIBILITY_TYPE_AGENT_ONLY_MANIFEST;
    case 4:
    case "IMAGE_COMPATIBILITY_TYPE_AGENT_CONTAINER_MANIFEST":
      return ImageCompatibilityType.IMAGE_COMPATIBILITY_TYPE_AGENT_CONTAINER_MANIFEST;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ImageCompatibilityType.UNRECOGNIZED;
  }
}

export function imageCompatibilityTypeToJSON(object: ImageCompatibilityType): string {
  switch (object) {
    case ImageCompatibilityType.IMAGE_COMPATIBILITY_TYPE_UNSPECIFIED:
      return "IMAGE_COMPATIBILITY_TYPE_UNSPECIFIED";
    case ImageCompatibilityType.IMAGE_COMPATIBILITY_TYPE_SONIC_AGENT:
      return "IMAGE_COMPATIBILITY_TYPE_SONIC_AGENT";
    case ImageCompatibilityType.IMAGE_COMPATIBILITY_TYPE_AGENT_FULL_MANIFEST:
      return "IMAGE_COMPATIBILITY_TYPE_AGENT_FULL_MANIFEST";
    case ImageCompatibilityType.IMAGE_COMPATIBILITY_TYPE_AGENT_ONLY_MANIFEST:
      return "IMAGE_COMPATIBILITY_TYPE_AGENT_ONLY_MANIFEST";
    case ImageCompatibilityType.IMAGE_COMPATIBILITY_TYPE_AGENT_CONTAINER_MANIFEST:
      return "IMAGE_COMPATIBILITY_TYPE_AGENT_CONTAINER_MANIFEST";
    case ImageCompatibilityType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** ImageState enumerates various fabric image update states. */
export enum ImageState {
  /** IMAGE_STATE_UNSPECIFIED - Unspecified image state */
  IMAGE_STATE_UNSPECIFIED = 0,
  /** IMAGE_STATE_TARGET_DOWNLOAD - The image target is selected for download outside the maintenance window */
  IMAGE_STATE_TARGET_DOWNLOAD = 1,
  /** IMAGE_STATE_TARGET_MAINTENANCE - The software maintenance mode is turned on while image target is set in the maintenance window. */
  IMAGE_STATE_TARGET_MAINTENANCE = 2,
  /** IMAGE_STATE_RUNNING_MAINTENANCE - The running image is set in maintenance window. */
  IMAGE_STATE_RUNNING_MAINTENANCE = 3,
  /** IMAGE_STATE_RUNNING_REGULAR - The running image is finalized for running outside the maintenance window */
  IMAGE_STATE_RUNNING_REGULAR = 4,
  UNRECOGNIZED = -1,
}

export function imageStateFromJSON(object: any): ImageState {
  switch (object) {
    case 0:
    case "IMAGE_STATE_UNSPECIFIED":
      return ImageState.IMAGE_STATE_UNSPECIFIED;
    case 1:
    case "IMAGE_STATE_TARGET_DOWNLOAD":
      return ImageState.IMAGE_STATE_TARGET_DOWNLOAD;
    case 2:
    case "IMAGE_STATE_TARGET_MAINTENANCE":
      return ImageState.IMAGE_STATE_TARGET_MAINTENANCE;
    case 3:
    case "IMAGE_STATE_RUNNING_MAINTENANCE":
      return ImageState.IMAGE_STATE_RUNNING_MAINTENANCE;
    case 4:
    case "IMAGE_STATE_RUNNING_REGULAR":
      return ImageState.IMAGE_STATE_RUNNING_REGULAR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ImageState.UNRECOGNIZED;
  }
}

export function imageStateToJSON(object: ImageState): string {
  switch (object) {
    case ImageState.IMAGE_STATE_UNSPECIFIED:
      return "IMAGE_STATE_UNSPECIFIED";
    case ImageState.IMAGE_STATE_TARGET_DOWNLOAD:
      return "IMAGE_STATE_TARGET_DOWNLOAD";
    case ImageState.IMAGE_STATE_TARGET_MAINTENANCE:
      return "IMAGE_STATE_TARGET_MAINTENANCE";
    case ImageState.IMAGE_STATE_RUNNING_MAINTENANCE:
      return "IMAGE_STATE_RUNNING_MAINTENANCE";
    case ImageState.IMAGE_STATE_RUNNING_REGULAR:
      return "IMAGE_STATE_RUNNING_REGULAR";
    case ImageState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** InterfaceType defines an enumeration of network interface types. */
export enum InterfaceType {
  /** INTERFACE_UNSPECIFIED - Unspecified interface type. */
  INTERFACE_UNSPECIFIED = 0,
  /** NETWORK_PORT_INTERFACE - Physical network port. */
  NETWORK_PORT_INTERFACE = 1,
  /** LOOPBACK_INTERFACE - Loopback interface. */
  LOOPBACK_INTERFACE = 2,
  /** VLAN_INTERFACE - VLAN interface or SVI. */
  VLAN_INTERFACE = 3,
  /** PORT_CHANNEL_INTERFACE - Port channel interface. */
  PORT_CHANNEL_INTERFACE = 4,
  /** SUB_PORT_INTERFACE - Sub-port of a sub-interface interface. */
  SUB_PORT_INTERFACE = 5,
  UNRECOGNIZED = -1,
}

export function interfaceTypeFromJSON(object: any): InterfaceType {
  switch (object) {
    case 0:
    case "INTERFACE_UNSPECIFIED":
      return InterfaceType.INTERFACE_UNSPECIFIED;
    case 1:
    case "NETWORK_PORT_INTERFACE":
      return InterfaceType.NETWORK_PORT_INTERFACE;
    case 2:
    case "LOOPBACK_INTERFACE":
      return InterfaceType.LOOPBACK_INTERFACE;
    case 3:
    case "VLAN_INTERFACE":
      return InterfaceType.VLAN_INTERFACE;
    case 4:
    case "PORT_CHANNEL_INTERFACE":
      return InterfaceType.PORT_CHANNEL_INTERFACE;
    case 5:
    case "SUB_PORT_INTERFACE":
      return InterfaceType.SUB_PORT_INTERFACE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return InterfaceType.UNRECOGNIZED;
  }
}

export function interfaceTypeToJSON(object: InterfaceType): string {
  switch (object) {
    case InterfaceType.INTERFACE_UNSPECIFIED:
      return "INTERFACE_UNSPECIFIED";
    case InterfaceType.NETWORK_PORT_INTERFACE:
      return "NETWORK_PORT_INTERFACE";
    case InterfaceType.LOOPBACK_INTERFACE:
      return "LOOPBACK_INTERFACE";
    case InterfaceType.VLAN_INTERFACE:
      return "VLAN_INTERFACE";
    case InterfaceType.PORT_CHANNEL_INTERFACE:
      return "PORT_CHANNEL_INTERFACE";
    case InterfaceType.SUB_PORT_INTERFACE:
      return "SUB_PORT_INTERFACE";
    case InterfaceType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** IpAddrType defines an enumeration of internet address types. */
export enum IPAddrType {
  /** IP_ADDR_UNSPECIFIED - Unspecified IP address type. */
  IP_ADDR_UNSPECIFIED = 0,
  /** IPV4 - IPv4 address type. */
  IPV4 = 1,
  /** IPV6 - IPv6 address type. */
  IPV6 = 2,
  UNRECOGNIZED = -1,
}

export function iPAddrTypeFromJSON(object: any): IPAddrType {
  switch (object) {
    case 0:
    case "IP_ADDR_UNSPECIFIED":
      return IPAddrType.IP_ADDR_UNSPECIFIED;
    case 1:
    case "IPV4":
      return IPAddrType.IPV4;
    case 2:
    case "IPV6":
      return IPAddrType.IPV6;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IPAddrType.UNRECOGNIZED;
  }
}

export function iPAddrTypeToJSON(object: IPAddrType): string {
  switch (object) {
    case IPAddrType.IP_ADDR_UNSPECIFIED:
      return "IP_ADDR_UNSPECIFIED";
    case IPAddrType.IPV4:
      return "IPV4";
    case IPAddrType.IPV6:
      return "IPV6";
    case IPAddrType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** IpmProbeType defines the ipm probe configuration between two topology groups */
export enum IpmProbeType {
  IPM_PROBE_TYPE_UNSPECIFIED = 0,
  BIDIRECTIONAL = 1,
  UNIDIRECTIONAL = 2,
  UNRECOGNIZED = -1,
}

export function ipmProbeTypeFromJSON(object: any): IpmProbeType {
  switch (object) {
    case 0:
    case "IPM_PROBE_TYPE_UNSPECIFIED":
      return IpmProbeType.IPM_PROBE_TYPE_UNSPECIFIED;
    case 1:
    case "BIDIRECTIONAL":
      return IpmProbeType.BIDIRECTIONAL;
    case 2:
    case "UNIDIRECTIONAL":
      return IpmProbeType.UNIDIRECTIONAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IpmProbeType.UNRECOGNIZED;
  }
}

export function ipmProbeTypeToJSON(object: IpmProbeType): string {
  switch (object) {
    case IpmProbeType.IPM_PROBE_TYPE_UNSPECIFIED:
      return "IPM_PROBE_TYPE_UNSPECIFIED";
    case IpmProbeType.BIDIRECTIONAL:
      return "BIDIRECTIONAL";
    case IpmProbeType.UNIDIRECTIONAL:
      return "UNIDIRECTIONAL";
    case IpmProbeType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** LacpMode defines an enumeration of LACP modes. */
export enum LacpMode {
  /** LACP_UNSPECIFIED - Unspecified LACP mode. */
  LACP_UNSPECIFIED = 0,
  /** LACP_ACTIVE - LACP active mode. */
  LACP_ACTIVE = 1,
  /** LACP_PASSIVE - LACP passive mode. */
  LACP_PASSIVE = 2,
  /** LACP_OFF - LACP is disabled. */
  LACP_OFF = 3,
  UNRECOGNIZED = -1,
}

export function lacpModeFromJSON(object: any): LacpMode {
  switch (object) {
    case 0:
    case "LACP_UNSPECIFIED":
      return LacpMode.LACP_UNSPECIFIED;
    case 1:
    case "LACP_ACTIVE":
      return LacpMode.LACP_ACTIVE;
    case 2:
    case "LACP_PASSIVE":
      return LacpMode.LACP_PASSIVE;
    case 3:
    case "LACP_OFF":
      return LacpMode.LACP_OFF;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LacpMode.UNRECOGNIZED;
  }
}

export function lacpModeToJSON(object: LacpMode): string {
  switch (object) {
    case LacpMode.LACP_UNSPECIFIED:
      return "LACP_UNSPECIFIED";
    case LacpMode.LACP_ACTIVE:
      return "LACP_ACTIVE";
    case LacpMode.LACP_PASSIVE:
      return "LACP_PASSIVE";
    case LacpMode.LACP_OFF:
      return "LACP_OFF";
    case LacpMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** MatchType defines an enumeration of conditional matching operators. */
export enum MatchType {
  /** MATCH_TYPE_UNSPECIFIED - Unspecified match operator. */
  MATCH_TYPE_UNSPECIFIED = 0,
  /** MATCH_EQ - Exact match or equality operator. */
  MATCH_EQ = 1,
  /** MATCH_GE - Greater than or equal operator. */
  MATCH_GE = 2,
  /** MATCH_LE - Less than or equal operator. */
  MATCH_LE = 3,
  /** MATCH_ANY - Match at least one of the items in a list. */
  MATCH_ANY = 4,
  UNRECOGNIZED = -1,
}

export function matchTypeFromJSON(object: any): MatchType {
  switch (object) {
    case 0:
    case "MATCH_TYPE_UNSPECIFIED":
      return MatchType.MATCH_TYPE_UNSPECIFIED;
    case 1:
    case "MATCH_EQ":
      return MatchType.MATCH_EQ;
    case 2:
    case "MATCH_GE":
      return MatchType.MATCH_GE;
    case 3:
    case "MATCH_LE":
      return MatchType.MATCH_LE;
    case 4:
    case "MATCH_ANY":
      return MatchType.MATCH_ANY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MatchType.UNRECOGNIZED;
  }
}

export function matchTypeToJSON(object: MatchType): string {
  switch (object) {
    case MatchType.MATCH_TYPE_UNSPECIFIED:
      return "MATCH_TYPE_UNSPECIFIED";
    case MatchType.MATCH_EQ:
      return "MATCH_EQ";
    case MatchType.MATCH_GE:
      return "MATCH_GE";
    case MatchType.MATCH_LE:
      return "MATCH_LE";
    case MatchType.MATCH_ANY:
      return "MATCH_ANY";
    case MatchType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** NodeRole defines an enumeration of roles that can be associated with a node. */
export enum NodeRole {
  /** NODE_ROLE_UNSPECIFIED - Unspecified node role. */
  NODE_ROLE_UNSPECIFIED = 0,
  /** LEAF - The node is a leaf node or mesh node. */
  LEAF = 1,
  /** SPINE - The node is a spine node. */
  SPINE = 2,
  /** SERVER - The node is a managed ucs server. */
  SERVER = 3,
  /** BORDER - The node is used as a border gateway. */
  BORDER = 4,
  /** RACK - The node is a rack with multiple child nodes. */
  RACK = 5,
  /** NONE - The node has no role. E.g. power shelf. */
  NONE = 6,
  UNRECOGNIZED = -1,
}

export function nodeRoleFromJSON(object: any): NodeRole {
  switch (object) {
    case 0:
    case "NODE_ROLE_UNSPECIFIED":
      return NodeRole.NODE_ROLE_UNSPECIFIED;
    case 1:
    case "LEAF":
      return NodeRole.LEAF;
    case 2:
    case "SPINE":
      return NodeRole.SPINE;
    case 3:
    case "SERVER":
      return NodeRole.SERVER;
    case 4:
    case "BORDER":
      return NodeRole.BORDER;
    case 5:
    case "RACK":
      return NodeRole.RACK;
    case 6:
    case "NONE":
      return NodeRole.NONE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NodeRole.UNRECOGNIZED;
  }
}

export function nodeRoleToJSON(object: NodeRole): string {
  switch (object) {
    case NodeRole.NODE_ROLE_UNSPECIFIED:
      return "NODE_ROLE_UNSPECIFIED";
    case NodeRole.LEAF:
      return "LEAF";
    case NodeRole.SPINE:
      return "SPINE";
    case NodeRole.SERVER:
      return "SERVER";
    case NodeRole.BORDER:
      return "BORDER";
    case NodeRole.RACK:
      return "RACK";
    case NodeRole.NONE:
      return "NONE";
    case NodeRole.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** NodeType defines an enumeration of node types. */
export enum NodeType {
  /** NODE_TYPE_UNSPECIFIED - Unspecified node type. */
  NODE_TYPE_UNSPECIFIED = 0,
  /** NODE_BLUEPRINT - The node is a blueprint or design mode node. */
  NODE_BLUEPRINT = 1,
  /** NODE_SWITCH - The node is a network switch. */
  NODE_SWITCH = 2,
  /** NODE_SERVER - The node is a managed gpu or storage server. */
  NODE_SERVER = 3,
  UNRECOGNIZED = -1,
}

export function nodeTypeFromJSON(object: any): NodeType {
  switch (object) {
    case 0:
    case "NODE_TYPE_UNSPECIFIED":
      return NodeType.NODE_TYPE_UNSPECIFIED;
    case 1:
    case "NODE_BLUEPRINT":
      return NodeType.NODE_BLUEPRINT;
    case 2:
    case "NODE_SWITCH":
      return NodeType.NODE_SWITCH;
    case 3:
    case "NODE_SERVER":
      return NodeType.NODE_SERVER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NodeType.UNRECOGNIZED;
  }
}

export function nodeTypeToJSON(object: NodeType): string {
  switch (object) {
    case NodeType.NODE_TYPE_UNSPECIFIED:
      return "NODE_TYPE_UNSPECIFIED";
    case NodeType.NODE_BLUEPRINT:
      return "NODE_BLUEPRINT";
    case NodeType.NODE_SWITCH:
      return "NODE_SWITCH";
    case NodeType.NODE_SERVER:
      return "NODE_SERVER";
    case NodeType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** PaketMirroringType enumerates various types of packet mirroring. */
export enum PacketMirroringType {
  /** PACKET_MIRRORING_UNSPECIFIED - Unspecified mirroring type. */
  PACKET_MIRRORING_UNSPECIFIED = 0,
  /** PACKET_MIRRORING_SPAN - Switch port analysis type. */
  PACKET_MIRRORING_SPAN = 1,
  /** PACKET_MIRRORING_ERSPAN - Encapsulated remote SPAN type. */
  PACKET_MIRRORING_ERSPAN = 2,
  UNRECOGNIZED = -1,
}

export function packetMirroringTypeFromJSON(object: any): PacketMirroringType {
  switch (object) {
    case 0:
    case "PACKET_MIRRORING_UNSPECIFIED":
      return PacketMirroringType.PACKET_MIRRORING_UNSPECIFIED;
    case 1:
    case "PACKET_MIRRORING_SPAN":
      return PacketMirroringType.PACKET_MIRRORING_SPAN;
    case 2:
    case "PACKET_MIRRORING_ERSPAN":
      return PacketMirroringType.PACKET_MIRRORING_ERSPAN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PacketMirroringType.UNRECOGNIZED;
  }
}

export function packetMirroringTypeToJSON(object: PacketMirroringType): string {
  switch (object) {
    case PacketMirroringType.PACKET_MIRRORING_UNSPECIFIED:
      return "PACKET_MIRRORING_UNSPECIFIED";
    case PacketMirroringType.PACKET_MIRRORING_SPAN:
      return "PACKET_MIRRORING_SPAN";
    case PacketMirroringType.PACKET_MIRRORING_ERSPAN:
      return "PACKET_MIRRORING_ERSPAN";
    case PacketMirroringType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * PlacementStrategy defines how the rails are placed on the switches in the switch
 * group they are associated with
 */
export enum PlacementStrategy {
  /** PLACEMENT_STRATEGY_TYPE_UNSPECIFIED - Unspecified placement type */
  PLACEMENT_STRATEGY_TYPE_UNSPECIFIED = 0,
  /** PLACEMENT_STRATEGY_TYPE_DENSE - Dense placement type */
  PLACEMENT_STRATEGY_TYPE_DENSE = 1,
  /** PLACEMENT_STRATEGY_TYPE_DISTRIBUTED - Distributed placement type */
  PLACEMENT_STRATEGY_TYPE_DISTRIBUTED = 2,
  UNRECOGNIZED = -1,
}

export function placementStrategyFromJSON(object: any): PlacementStrategy {
  switch (object) {
    case 0:
    case "PLACEMENT_STRATEGY_TYPE_UNSPECIFIED":
      return PlacementStrategy.PLACEMENT_STRATEGY_TYPE_UNSPECIFIED;
    case 1:
    case "PLACEMENT_STRATEGY_TYPE_DENSE":
      return PlacementStrategy.PLACEMENT_STRATEGY_TYPE_DENSE;
    case 2:
    case "PLACEMENT_STRATEGY_TYPE_DISTRIBUTED":
      return PlacementStrategy.PLACEMENT_STRATEGY_TYPE_DISTRIBUTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PlacementStrategy.UNRECOGNIZED;
  }
}

export function placementStrategyToJSON(object: PlacementStrategy): string {
  switch (object) {
    case PlacementStrategy.PLACEMENT_STRATEGY_TYPE_UNSPECIFIED:
      return "PLACEMENT_STRATEGY_TYPE_UNSPECIFIED";
    case PlacementStrategy.PLACEMENT_STRATEGY_TYPE_DENSE:
      return "PLACEMENT_STRATEGY_TYPE_DENSE";
    case PlacementStrategy.PLACEMENT_STRATEGY_TYPE_DISTRIBUTED:
      return "PLACEMENT_STRATEGY_TYPE_DISTRIBUTED";
    case PlacementStrategy.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** PluggableType defines an enumeration of pluggable and optic options. */
export enum PluggableType {
  /** PLUGGABLE_TYPE_UNSPECIFIED - Unspecified pluggable type. */
  PLUGGABLE_TYPE_UNSPECIFIED = 0,
  /** QSFP - QSFP pluggable type. */
  QSFP = 1,
  UNRECOGNIZED = -1,
}

export function pluggableTypeFromJSON(object: any): PluggableType {
  switch (object) {
    case 0:
    case "PLUGGABLE_TYPE_UNSPECIFIED":
      return PluggableType.PLUGGABLE_TYPE_UNSPECIFIED;
    case 1:
    case "QSFP":
      return PluggableType.QSFP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PluggableType.UNRECOGNIZED;
  }
}

export function pluggableTypeToJSON(object: PluggableType): string {
  switch (object) {
    case PluggableType.PLUGGABLE_TYPE_UNSPECIFIED:
      return "PLUGGABLE_TYPE_UNSPECIFIED";
    case PluggableType.QSFP:
      return "QSFP";
    case PluggableType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * PortConfigType defines an enumeration of roles of ports or port channels for the cabling algorithm
 * (intended to decouple it from PortRole).
 */
export enum PortConfigType {
  /** PORT_CONFIG_TYPE_UNSPECIFIED - Unspecified port role config. */
  PORT_CONFIG_TYPE_UNSPECIFIED = 0,
  /** PORT_CONFIG_TYPE_LOGICAL - This port has configuration that would make it unsuitable for a fabric port. ex, vlan, vni, port channel */
  PORT_CONFIG_TYPE_LOGICAL = 1,
  /**
   * PORT_CONFIG_TYPE_NON_DEFAULT - The port does not have logical config, but has some breakout/speed override applied. It can be used for
   * connections matching its config
   */
  PORT_CONFIG_TYPE_NON_DEFAULT = 2,
  UNRECOGNIZED = -1,
}

export function portConfigTypeFromJSON(object: any): PortConfigType {
  switch (object) {
    case 0:
    case "PORT_CONFIG_TYPE_UNSPECIFIED":
      return PortConfigType.PORT_CONFIG_TYPE_UNSPECIFIED;
    case 1:
    case "PORT_CONFIG_TYPE_LOGICAL":
      return PortConfigType.PORT_CONFIG_TYPE_LOGICAL;
    case 2:
    case "PORT_CONFIG_TYPE_NON_DEFAULT":
      return PortConfigType.PORT_CONFIG_TYPE_NON_DEFAULT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PortConfigType.UNRECOGNIZED;
  }
}

export function portConfigTypeToJSON(object: PortConfigType): string {
  switch (object) {
    case PortConfigType.PORT_CONFIG_TYPE_UNSPECIFIED:
      return "PORT_CONFIG_TYPE_UNSPECIFIED";
    case PortConfigType.PORT_CONFIG_TYPE_LOGICAL:
      return "PORT_CONFIG_TYPE_LOGICAL";
    case PortConfigType.PORT_CONFIG_TYPE_NON_DEFAULT:
      return "PORT_CONFIG_TYPE_NON_DEFAULT";
    case PortConfigType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** PortRegion defines an enumeration fabric or non-fabric port regions. */
export enum PortRegion {
  /** PORT_REGION_UNSPECIFIED - Unspecified port regions. */
  PORT_REGION_UNSPECIFIED = 0,
  /** PORT_REGION_FABRIC - A port region corresponding to a fabric region. */
  PORT_REGION_FABRIC = 1,
  /** PORT_REGION_NON_FABRIC - A port region corresponding to a non-fabric region. */
  PORT_REGION_NON_FABRIC = 2,
  UNRECOGNIZED = -1,
}

export function portRegionFromJSON(object: any): PortRegion {
  switch (object) {
    case 0:
    case "PORT_REGION_UNSPECIFIED":
      return PortRegion.PORT_REGION_UNSPECIFIED;
    case 1:
    case "PORT_REGION_FABRIC":
      return PortRegion.PORT_REGION_FABRIC;
    case 2:
    case "PORT_REGION_NON_FABRIC":
      return PortRegion.PORT_REGION_NON_FABRIC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PortRegion.UNRECOGNIZED;
  }
}

export function portRegionToJSON(object: PortRegion): string {
  switch (object) {
    case PortRegion.PORT_REGION_UNSPECIFIED:
      return "PORT_REGION_UNSPECIFIED";
    case PortRegion.PORT_REGION_FABRIC:
      return "PORT_REGION_FABRIC";
    case PortRegion.PORT_REGION_NON_FABRIC:
      return "PORT_REGION_NON_FABRIC";
    case PortRegion.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** PortRole defines an enumeration of roles of ports or port channels. */
export enum PortRole {
  /** PORT_ROLE_UNSPECIFIED - Unspecified port role. */
  PORT_ROLE_UNSPECIFIED = 0,
  /** UNUSED_PORT - The port is not used. */
  UNUSED_PORT = 1,
  /** FABRIC_PORT - The port is a fabric port. */
  FABRIC_PORT = 2,
  /** HOST_PORT - The port is a host port. */
  HOST_PORT = 3,
  /** ROUTED_PORT - The port is a routed port or a port with IP addresses. */
  ROUTED_PORT = 4,
  /** LAG_PORT - The port is attached to a port channel (LAG/MLAG). */
  LAG_PORT = 5,
  /** BORDER_PORT - The port is used for DC interconnect. */
  BORDER_PORT = 6,
  UNRECOGNIZED = -1,
}

export function portRoleFromJSON(object: any): PortRole {
  switch (object) {
    case 0:
    case "PORT_ROLE_UNSPECIFIED":
      return PortRole.PORT_ROLE_UNSPECIFIED;
    case 1:
    case "UNUSED_PORT":
      return PortRole.UNUSED_PORT;
    case 2:
    case "FABRIC_PORT":
      return PortRole.FABRIC_PORT;
    case 3:
    case "HOST_PORT":
      return PortRole.HOST_PORT;
    case 4:
    case "ROUTED_PORT":
      return PortRole.ROUTED_PORT;
    case 5:
    case "LAG_PORT":
      return PortRole.LAG_PORT;
    case 6:
    case "BORDER_PORT":
      return PortRole.BORDER_PORT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PortRole.UNRECOGNIZED;
  }
}

export function portRoleToJSON(object: PortRole): string {
  switch (object) {
    case PortRole.PORT_ROLE_UNSPECIFIED:
      return "PORT_ROLE_UNSPECIFIED";
    case PortRole.UNUSED_PORT:
      return "UNUSED_PORT";
    case PortRole.FABRIC_PORT:
      return "FABRIC_PORT";
    case PortRole.HOST_PORT:
      return "HOST_PORT";
    case PortRole.ROUTED_PORT:
      return "ROUTED_PORT";
    case PortRole.LAG_PORT:
      return "LAG_PORT";
    case PortRole.BORDER_PORT:
      return "BORDER_PORT";
    case PortRole.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** PortType defines an enumeration of categories of ports. */
export enum PortType {
  PORT_TYPE_UNSPECIFIED = 0,
  DATA_PORT = 1,
  MGMT_PORT = 2,
  BMC_PORT = 3,
  UNRECOGNIZED = -1,
}

export function portTypeFromJSON(object: any): PortType {
  switch (object) {
    case 0:
    case "PORT_TYPE_UNSPECIFIED":
      return PortType.PORT_TYPE_UNSPECIFIED;
    case 1:
    case "DATA_PORT":
      return PortType.DATA_PORT;
    case 2:
    case "MGMT_PORT":
      return PortType.MGMT_PORT;
    case 3:
    case "BMC_PORT":
      return PortType.BMC_PORT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PortType.UNRECOGNIZED;
  }
}

export function portTypeToJSON(object: PortType): string {
  switch (object) {
    case PortType.PORT_TYPE_UNSPECIFIED:
      return "PORT_TYPE_UNSPECIFIED";
    case PortType.DATA_PORT:
      return "DATA_PORT";
    case PortType.MGMT_PORT:
      return "MGMT_PORT";
    case PortType.BMC_PORT:
      return "BMC_PORT";
    case PortType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Protocol enumerates various L4 protocol types. Network protocols are
 * global, and therefore no prefix is needed for the enums.
 */
export enum Protocol {
  /** PROTOCOL_UNSPECIFIED - Unspecified protocol. */
  PROTOCOL_UNSPECIFIED = 0,
  /** TCP - TCP protocol. */
  TCP = 1,
  /** UDP - UDP protocol. */
  UDP = 2,
  /** ICMP - ICMP protocol. */
  ICMP = 3,
  UNRECOGNIZED = -1,
}

export function protocolFromJSON(object: any): Protocol {
  switch (object) {
    case 0:
    case "PROTOCOL_UNSPECIFIED":
      return Protocol.PROTOCOL_UNSPECIFIED;
    case 1:
    case "TCP":
      return Protocol.TCP;
    case 2:
    case "UDP":
      return Protocol.UDP;
    case 3:
    case "ICMP":
      return Protocol.ICMP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Protocol.UNRECOGNIZED;
  }
}

export function protocolToJSON(object: Protocol): string {
  switch (object) {
    case Protocol.PROTOCOL_UNSPECIFIED:
      return "PROTOCOL_UNSPECIFIED";
    case Protocol.TCP:
      return "TCP";
    case Protocol.UDP:
      return "UDP";
    case Protocol.ICMP:
      return "ICMP";
    case Protocol.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** PsuType enumerates various types of psus. */
export enum PsuType {
  /** PSU_TYPE_UNSPECIFIED - Unspecified psu type. */
  PSU_TYPE_UNSPECIFIED = 0,
  /** PSU_TYPE_AC - The psu type is AC power supply. */
  PSU_TYPE_AC = 1,
  /** PSU_TYPE_DC - The psu type is DC power supply. */
  PSU_TYPE_DC = 2,
  /** PSU_TYPE_PUV - The psu type is Platinum Universal AC/DC power supply. */
  PSU_TYPE_PUV = 3,
  /** PSU_TYPE_PHV - The psu type is Platinum High-Voltage AC/DC power supply. */
  PSU_TYPE_PHV = 4,
  UNRECOGNIZED = -1,
}

export function psuTypeFromJSON(object: any): PsuType {
  switch (object) {
    case 0:
    case "PSU_TYPE_UNSPECIFIED":
      return PsuType.PSU_TYPE_UNSPECIFIED;
    case 1:
    case "PSU_TYPE_AC":
      return PsuType.PSU_TYPE_AC;
    case 2:
    case "PSU_TYPE_DC":
      return PsuType.PSU_TYPE_DC;
    case 3:
    case "PSU_TYPE_PUV":
      return PsuType.PSU_TYPE_PUV;
    case 4:
    case "PSU_TYPE_PHV":
      return PsuType.PSU_TYPE_PHV;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PsuType.UNRECOGNIZED;
  }
}

export function psuTypeToJSON(object: PsuType): string {
  switch (object) {
    case PsuType.PSU_TYPE_UNSPECIFIED:
      return "PSU_TYPE_UNSPECIFIED";
    case PsuType.PSU_TYPE_AC:
      return "PSU_TYPE_AC";
    case PsuType.PSU_TYPE_DC:
      return "PSU_TYPE_DC";
    case PsuType.PSU_TYPE_PUV:
      return "PSU_TYPE_PUV";
    case PsuType.PSU_TYPE_PHV:
      return "PSU_TYPE_PHV";
    case PsuType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** RefPointJobState defines an enumeration of reference point job states. */
export enum RefPointJobState {
  /** JOB_STATE_UNSPECIFIED - Unspecified reference point job state. */
  JOB_STATE_UNSPECIFIED = 0,
  /** JOB_STATE_NOT_REQUESTED - The reference point job is pending. */
  JOB_STATE_NOT_REQUESTED = 1,
  /** JOB_STATE_QUEUED - The reference point job is running. */
  JOB_STATE_QUEUED = 2,
  /** JOB_STATE_PROCESSING - The reference point job has completed. */
  JOB_STATE_PROCESSING = 3,
  /** JOB_STATE_READY - The reference point job has failed. */
  JOB_STATE_READY = 4,
  /** JOB_STATE_FAILED - The reference point job has been canceled. */
  JOB_STATE_FAILED = 5,
  UNRECOGNIZED = -1,
}

export function refPointJobStateFromJSON(object: any): RefPointJobState {
  switch (object) {
    case 0:
    case "JOB_STATE_UNSPECIFIED":
      return RefPointJobState.JOB_STATE_UNSPECIFIED;
    case 1:
    case "JOB_STATE_NOT_REQUESTED":
      return RefPointJobState.JOB_STATE_NOT_REQUESTED;
    case 2:
    case "JOB_STATE_QUEUED":
      return RefPointJobState.JOB_STATE_QUEUED;
    case 3:
    case "JOB_STATE_PROCESSING":
      return RefPointJobState.JOB_STATE_PROCESSING;
    case 4:
    case "JOB_STATE_READY":
      return RefPointJobState.JOB_STATE_READY;
    case 5:
    case "JOB_STATE_FAILED":
      return RefPointJobState.JOB_STATE_FAILED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RefPointJobState.UNRECOGNIZED;
  }
}

export function refPointJobStateToJSON(object: RefPointJobState): string {
  switch (object) {
    case RefPointJobState.JOB_STATE_UNSPECIFIED:
      return "JOB_STATE_UNSPECIFIED";
    case RefPointJobState.JOB_STATE_NOT_REQUESTED:
      return "JOB_STATE_NOT_REQUESTED";
    case RefPointJobState.JOB_STATE_QUEUED:
      return "JOB_STATE_QUEUED";
    case RefPointJobState.JOB_STATE_PROCESSING:
      return "JOB_STATE_PROCESSING";
    case RefPointJobState.JOB_STATE_READY:
      return "JOB_STATE_READY";
    case RefPointJobState.JOB_STATE_FAILED:
      return "JOB_STATE_FAILED";
    case RefPointJobState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** RouteOriginType defines an enumeration of BGP route origins. */
export enum RouteOriginType {
  /** ROUTE_ORIGIN_UNSPECIFIED - Unspecified route origin. */
  ROUTE_ORIGIN_UNSPECIFIED = 0,
  /** ROUTE_ORIGIN_EBGP - EBGP route origin. */
  ROUTE_ORIGIN_EBGP = 1,
  /** ROUTE_ORIGIN_IBGP - IBGP route origin. */
  ROUTE_ORIGIN_IBGP = 2,
  UNRECOGNIZED = -1,
}

export function routeOriginTypeFromJSON(object: any): RouteOriginType {
  switch (object) {
    case 0:
    case "ROUTE_ORIGIN_UNSPECIFIED":
      return RouteOriginType.ROUTE_ORIGIN_UNSPECIFIED;
    case 1:
    case "ROUTE_ORIGIN_EBGP":
      return RouteOriginType.ROUTE_ORIGIN_EBGP;
    case 2:
    case "ROUTE_ORIGIN_IBGP":
      return RouteOriginType.ROUTE_ORIGIN_IBGP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RouteOriginType.UNRECOGNIZED;
  }
}

export function routeOriginTypeToJSON(object: RouteOriginType): string {
  switch (object) {
    case RouteOriginType.ROUTE_ORIGIN_UNSPECIFIED:
      return "ROUTE_ORIGIN_UNSPECIFIED";
    case RouteOriginType.ROUTE_ORIGIN_EBGP:
      return "ROUTE_ORIGIN_EBGP";
    case RouteOriginType.ROUTE_ORIGIN_IBGP:
      return "ROUTE_ORIGIN_IBGP";
    case RouteOriginType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * RouteTag enumerates color tags for BGP routes. RouteTag applied to objects
 * such as NetworkPort, Loopback etc. is used only when a relevant BGP policy
 * exists in the VRF.
 */
export enum RouteTag {
  /** TAG_UNSPECIFIED - Unspecified tag. */
  TAG_UNSPECIFIED = 0,
  /** TAG_AMBER - Default route tag. */
  TAG_AMBER = 1,
  /** TAG_BLACK - Route tag used by discard or blackhole routes. */
  TAG_BLACK = 2,
  /** TAG_BLUE - User-defined route tag "blue". */
  TAG_BLUE = 3,
  /** TAG_GREEN - User-defined route tag "green". */
  TAG_GREEN = 4,
  /** TAG_RED - User-defined route tag "red". */
  TAG_RED = 5,
  /** TAG_PURPLE - User-defined route tag "purple". */
  TAG_PURPLE = 6,
  /** TAG_YELLOW - User-defined route tag "yellow". */
  TAG_YELLOW = 7,
  UNRECOGNIZED = -1,
}

export function routeTagFromJSON(object: any): RouteTag {
  switch (object) {
    case 0:
    case "TAG_UNSPECIFIED":
      return RouteTag.TAG_UNSPECIFIED;
    case 1:
    case "TAG_AMBER":
      return RouteTag.TAG_AMBER;
    case 2:
    case "TAG_BLACK":
      return RouteTag.TAG_BLACK;
    case 3:
    case "TAG_BLUE":
      return RouteTag.TAG_BLUE;
    case 4:
    case "TAG_GREEN":
      return RouteTag.TAG_GREEN;
    case 5:
    case "TAG_RED":
      return RouteTag.TAG_RED;
    case 6:
    case "TAG_PURPLE":
      return RouteTag.TAG_PURPLE;
    case 7:
    case "TAG_YELLOW":
      return RouteTag.TAG_YELLOW;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RouteTag.UNRECOGNIZED;
  }
}

export function routeTagToJSON(object: RouteTag): string {
  switch (object) {
    case RouteTag.TAG_UNSPECIFIED:
      return "TAG_UNSPECIFIED";
    case RouteTag.TAG_AMBER:
      return "TAG_AMBER";
    case RouteTag.TAG_BLACK:
      return "TAG_BLACK";
    case RouteTag.TAG_BLUE:
      return "TAG_BLUE";
    case RouteTag.TAG_GREEN:
      return "TAG_GREEN";
    case RouteTag.TAG_RED:
      return "TAG_RED";
    case RouteTag.TAG_PURPLE:
      return "TAG_PURPLE";
    case RouteTag.TAG_YELLOW:
      return "TAG_YELLOW";
    case RouteTag.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** RouteType defines an enumeration of BGP EVPN route types from 1 to 5. */
export enum RouteType {
  /** ROUTE_TYPE_UNSPECIFIED - Unspecified route type. */
  ROUTE_TYPE_UNSPECIFIED = 0,
  /** ROUTE_EAD - Ethernet auto-discovery route type. */
  ROUTE_EAD = 1,
  /** ROUTE_MAC_IP - MAC/IP route type. */
  ROUTE_MAC_IP = 2,
  /** ROUTE_MULTICAST - Multicast route type. */
  ROUTE_MULTICAST = 3,
  /** ROUTE_ES - Ethernet segment route type */
  ROUTE_ES = 4,
  /** ROUTE_PREFIX - Prefix route type. */
  ROUTE_PREFIX = 5,
  UNRECOGNIZED = -1,
}

export function routeTypeFromJSON(object: any): RouteType {
  switch (object) {
    case 0:
    case "ROUTE_TYPE_UNSPECIFIED":
      return RouteType.ROUTE_TYPE_UNSPECIFIED;
    case 1:
    case "ROUTE_EAD":
      return RouteType.ROUTE_EAD;
    case 2:
    case "ROUTE_MAC_IP":
      return RouteType.ROUTE_MAC_IP;
    case 3:
    case "ROUTE_MULTICAST":
      return RouteType.ROUTE_MULTICAST;
    case 4:
    case "ROUTE_ES":
      return RouteType.ROUTE_ES;
    case 5:
    case "ROUTE_PREFIX":
      return RouteType.ROUTE_PREFIX;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RouteType.UNRECOGNIZED;
  }
}

export function routeTypeToJSON(object: RouteType): string {
  switch (object) {
    case RouteType.ROUTE_TYPE_UNSPECIFIED:
      return "ROUTE_TYPE_UNSPECIFIED";
    case RouteType.ROUTE_EAD:
      return "ROUTE_EAD";
    case RouteType.ROUTE_MAC_IP:
      return "ROUTE_MAC_IP";
    case RouteType.ROUTE_MULTICAST:
      return "ROUTE_MULTICAST";
    case RouteType.ROUTE_ES:
      return "ROUTE_ES";
    case RouteType.ROUTE_PREFIX:
      return "ROUTE_PREFIX";
    case RouteType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** ServerPortGroupType enumerates various categories of server ports */
export enum ServerPortGroupType {
  SERVER_PORT_GROUP_TYPE_UNSPECIFIED = 0,
  NORTH_SOUTH = 1,
  EAST_WEST = 2,
  NORTH_SOUTH_BMC = 3,
  LOM_ETHERNET = 4,
  BMC = 5,
  EAST_WEST_BMC = 6,
  DCSCM_LOM_ETHERNET = 7,
  TOR_SW_FABRIC_PORTS = 8,
  UNRECOGNIZED = -1,
}

export function serverPortGroupTypeFromJSON(object: any): ServerPortGroupType {
  switch (object) {
    case 0:
    case "SERVER_PORT_GROUP_TYPE_UNSPECIFIED":
      return ServerPortGroupType.SERVER_PORT_GROUP_TYPE_UNSPECIFIED;
    case 1:
    case "NORTH_SOUTH":
      return ServerPortGroupType.NORTH_SOUTH;
    case 2:
    case "EAST_WEST":
      return ServerPortGroupType.EAST_WEST;
    case 3:
    case "NORTH_SOUTH_BMC":
      return ServerPortGroupType.NORTH_SOUTH_BMC;
    case 4:
    case "LOM_ETHERNET":
      return ServerPortGroupType.LOM_ETHERNET;
    case 5:
    case "BMC":
      return ServerPortGroupType.BMC;
    case 6:
    case "EAST_WEST_BMC":
      return ServerPortGroupType.EAST_WEST_BMC;
    case 7:
    case "DCSCM_LOM_ETHERNET":
      return ServerPortGroupType.DCSCM_LOM_ETHERNET;
    case 8:
    case "TOR_SW_FABRIC_PORTS":
      return ServerPortGroupType.TOR_SW_FABRIC_PORTS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ServerPortGroupType.UNRECOGNIZED;
  }
}

export function serverPortGroupTypeToJSON(object: ServerPortGroupType): string {
  switch (object) {
    case ServerPortGroupType.SERVER_PORT_GROUP_TYPE_UNSPECIFIED:
      return "SERVER_PORT_GROUP_TYPE_UNSPECIFIED";
    case ServerPortGroupType.NORTH_SOUTH:
      return "NORTH_SOUTH";
    case ServerPortGroupType.EAST_WEST:
      return "EAST_WEST";
    case ServerPortGroupType.NORTH_SOUTH_BMC:
      return "NORTH_SOUTH_BMC";
    case ServerPortGroupType.LOM_ETHERNET:
      return "LOM_ETHERNET";
    case ServerPortGroupType.BMC:
      return "BMC";
    case ServerPortGroupType.EAST_WEST_BMC:
      return "EAST_WEST_BMC";
    case ServerPortGroupType.DCSCM_LOM_ETHERNET:
      return "DCSCM_LOM_ETHERNET";
    case ServerPortGroupType.TOR_SW_FABRIC_PORTS:
      return "TOR_SW_FABRIC_PORTS";
    case ServerPortGroupType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** SoftwareMode specifies the operation mode of the fabric software */
export enum SoftwareMode {
  /** SOFTWARE_MODE_UNSPECIFIED - The software mode is unspecified. */
  SOFTWARE_MODE_UNSPECIFIED = 0,
  /** SOFTWARE_MODE_MAINTENANCE_ON - The software is in maintenance mode. */
  SOFTWARE_MODE_MAINTENANCE_ON = 1,
  /** SOFTWARE_MODE_MAINTENANCE_OFF - The software is operating in the regular mode, outside the maintenance window. */
  SOFTWARE_MODE_MAINTENANCE_OFF = 2,
  UNRECOGNIZED = -1,
}

export function softwareModeFromJSON(object: any): SoftwareMode {
  switch (object) {
    case 0:
    case "SOFTWARE_MODE_UNSPECIFIED":
      return SoftwareMode.SOFTWARE_MODE_UNSPECIFIED;
    case 1:
    case "SOFTWARE_MODE_MAINTENANCE_ON":
      return SoftwareMode.SOFTWARE_MODE_MAINTENANCE_ON;
    case 2:
    case "SOFTWARE_MODE_MAINTENANCE_OFF":
      return SoftwareMode.SOFTWARE_MODE_MAINTENANCE_OFF;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SoftwareMode.UNRECOGNIZED;
  }
}

export function softwareModeToJSON(object: SoftwareMode): string {
  switch (object) {
    case SoftwareMode.SOFTWARE_MODE_UNSPECIFIED:
      return "SOFTWARE_MODE_UNSPECIFIED";
    case SoftwareMode.SOFTWARE_MODE_MAINTENANCE_ON:
      return "SOFTWARE_MODE_MAINTENANCE_ON";
    case SoftwareMode.SOFTWARE_MODE_MAINTENANCE_OFF:
      return "SOFTWARE_MODE_MAINTENANCE_OFF";
    case SoftwareMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** TaskStatusType defines an enumeration of task execution status types. */
export enum TaskStatusType {
  /** TASK_STATUS_UNSPECIFIED - Unspecified task status. */
  TASK_STATUS_UNSPECIFIED = 0,
  /** TASK_STATUS_PENDING - Task is in the middle of execution. */
  TASK_STATUS_PENDING = 1,
  /** TASK_STATUS_COMPLETED - Task finished successfully. */
  TASK_STATUS_COMPLETED = 2,
  /** TASK_STATUS_ERROR - Task failed with error. */
  TASK_STATUS_ERROR = 3,
  UNRECOGNIZED = -1,
}

export function taskStatusTypeFromJSON(object: any): TaskStatusType {
  switch (object) {
    case 0:
    case "TASK_STATUS_UNSPECIFIED":
      return TaskStatusType.TASK_STATUS_UNSPECIFIED;
    case 1:
    case "TASK_STATUS_PENDING":
      return TaskStatusType.TASK_STATUS_PENDING;
    case 2:
    case "TASK_STATUS_COMPLETED":
      return TaskStatusType.TASK_STATUS_COMPLETED;
    case 3:
    case "TASK_STATUS_ERROR":
      return TaskStatusType.TASK_STATUS_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TaskStatusType.UNRECOGNIZED;
  }
}

export function taskStatusTypeToJSON(object: TaskStatusType): string {
  switch (object) {
    case TaskStatusType.TASK_STATUS_UNSPECIFIED:
      return "TASK_STATUS_UNSPECIFIED";
    case TaskStatusType.TASK_STATUS_PENDING:
      return "TASK_STATUS_PENDING";
    case TaskStatusType.TASK_STATUS_COMPLETED:
      return "TASK_STATUS_COMPLETED";
    case TaskStatusType.TASK_STATUS_ERROR:
      return "TASK_STATUS_ERROR";
    case TaskStatusType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** TopologyGroupType defines the type of a group in the topology */
export enum TopologyGroupType {
  /** TOPOLOGY_GROUP_TYPE_UNSPECIFIED - Unspecified group type */
  TOPOLOGY_GROUP_TYPE_UNSPECIFIED = 0,
  /** TOPOLOGY_GROUP_TYPE_SWITCH_GROUP - A topology group with switch hardware sets */
  TOPOLOGY_GROUP_TYPE_SWITCH_GROUP = 1,
  /** TOPOLOGY_GROUP_TYPE_SERVER_GROUP - A topology group with server hardware sets */
  TOPOLOGY_GROUP_TYPE_SERVER_GROUP = 2,
  /** TOPOLOGY_GROUP_TYPE_RAIL_GROUP - A topology group with rails */
  TOPOLOGY_GROUP_TYPE_RAIL_GROUP = 3,
  UNRECOGNIZED = -1,
}

export function topologyGroupTypeFromJSON(object: any): TopologyGroupType {
  switch (object) {
    case 0:
    case "TOPOLOGY_GROUP_TYPE_UNSPECIFIED":
      return TopologyGroupType.TOPOLOGY_GROUP_TYPE_UNSPECIFIED;
    case 1:
    case "TOPOLOGY_GROUP_TYPE_SWITCH_GROUP":
      return TopologyGroupType.TOPOLOGY_GROUP_TYPE_SWITCH_GROUP;
    case 2:
    case "TOPOLOGY_GROUP_TYPE_SERVER_GROUP":
      return TopologyGroupType.TOPOLOGY_GROUP_TYPE_SERVER_GROUP;
    case 3:
    case "TOPOLOGY_GROUP_TYPE_RAIL_GROUP":
      return TopologyGroupType.TOPOLOGY_GROUP_TYPE_RAIL_GROUP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TopologyGroupType.UNRECOGNIZED;
  }
}

export function topologyGroupTypeToJSON(object: TopologyGroupType): string {
  switch (object) {
    case TopologyGroupType.TOPOLOGY_GROUP_TYPE_UNSPECIFIED:
      return "TOPOLOGY_GROUP_TYPE_UNSPECIFIED";
    case TopologyGroupType.TOPOLOGY_GROUP_TYPE_SWITCH_GROUP:
      return "TOPOLOGY_GROUP_TYPE_SWITCH_GROUP";
    case TopologyGroupType.TOPOLOGY_GROUP_TYPE_SERVER_GROUP:
      return "TOPOLOGY_GROUP_TYPE_SERVER_GROUP";
    case TopologyGroupType.TOPOLOGY_GROUP_TYPE_RAIL_GROUP:
      return "TOPOLOGY_GROUP_TYPE_RAIL_GROUP";
    case TopologyGroupType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** BreakoutMode encapsulates properties of a port breakout mode. */
export interface BreakoutMode {
  /** Mode defines breakout mode. E.g. 2x200G(2). */
  mode: string;
  /** Short description of the breakout mode. E.g. Two 200G ports using 2 lanes each. */
  description: string;
  /** IsDefault indicates if the mode is the default mode of the port. */
  isDefault: boolean;
  /** FecModes defines supported FEC modes. */
  fecModes: string[];
  /** Ports defines the names of base network ports. */
  ports: string[];
  /** NumPorts defines the number of breakout ports. */
  numPorts: number;
  /** Speed defines the speed of each breakout port. */
  speed: string;
  /** Default pluggable or PID of cable defined for a specific device breakout mode. */
  defaultPluggable: string;
  /** Server port group type */
  groupTypes: ServerPortGroupType[];
}

/** Port group defines the properties of a group of server ports */
export interface ServerPortGroup {
  /** Server port group type */
  groupType: ServerPortGroupType;
  /** Port type (data/mgmt) */
  portType: PortType;
  /** NumPorts defines the number of ports per slot in the server port group. */
  numPortsPerSlot: number;
  /** Speed defines the speed of each port in this server port group. */
  speed: string;
  /** Slots define the static slot numbers the port group is present on for the device. */
  slotNumbers: number[];
  /** Default pluggable or PID of cable defined for a specific server port group type. */
  defaultPluggable: string;
  /** Limit on the number of connections for this port group type. Currently applicable to LOM ports. */
  groupConnectionLimit: number;
  /**
   * PortSetId refers to the position/index of the portGroup notably for east-west ports in the C880
   * for which there are multiple ports per slot. An id of zero means the there is only one portGroup
   * of a given type (no breakout); any non-zero value will refer a portGroup in a broken out list.
   */
  portSetId: number;
}

function createBaseBreakoutMode(): BreakoutMode {
  return {
    mode: "",
    description: "",
    isDefault: false,
    fecModes: [],
    ports: [],
    numPorts: 0,
    speed: "",
    defaultPluggable: "",
    groupTypes: [],
  };
}

export const BreakoutMode: MessageFns<BreakoutMode> = {
  encode(message: BreakoutMode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mode !== "") {
      writer.uint32(10).string(message.mode);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    if (message.isDefault !== false) {
      writer.uint32(24).bool(message.isDefault);
    }
    for (const v of message.fecModes) {
      writer.uint32(50).string(v!);
    }
    for (const v of message.ports) {
      writer.uint32(66).string(v!);
    }
    if (message.numPorts !== 0) {
      writer.uint32(72).uint32(message.numPorts);
    }
    if (message.speed !== "") {
      writer.uint32(82).string(message.speed);
    }
    if (message.defaultPluggable !== "") {
      writer.uint32(90).string(message.defaultPluggable);
    }
    writer.uint32(98).fork();
    for (const v of message.groupTypes) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BreakoutMode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBreakoutMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mode = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isDefault = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fecModes.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.ports.push(reader.string());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.numPorts = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.speed = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.defaultPluggable = reader.string();
          continue;
        }
        case 12: {
          if (tag === 96) {
            message.groupTypes.push(reader.int32() as any);

            continue;
          }

          if (tag === 98) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.groupTypes.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BreakoutMode {
    return {
      mode: isSet(object.mode) ? globalThis.String(object.mode) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      isDefault: isSet(object.isDefault) ? globalThis.Boolean(object.isDefault) : false,
      fecModes: globalThis.Array.isArray(object?.fecModes) ? object.fecModes.map((e: any) => globalThis.String(e)) : [],
      ports: globalThis.Array.isArray(object?.ports) ? object.ports.map((e: any) => globalThis.String(e)) : [],
      numPorts: isSet(object.numPorts) ? globalThis.Number(object.numPorts) : 0,
      speed: isSet(object.speed) ? globalThis.String(object.speed) : "",
      defaultPluggable: isSet(object.defaultPluggable) ? globalThis.String(object.defaultPluggable) : "",
      groupTypes: globalThis.Array.isArray(object?.groupTypes)
        ? object.groupTypes.map((e: any) => serverPortGroupTypeFromJSON(e))
        : [],
    };
  },

  toJSON(message: BreakoutMode): unknown {
    const obj: any = {};
    if (message.mode !== "") {
      obj.mode = message.mode;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.isDefault !== false) {
      obj.isDefault = message.isDefault;
    }
    if (message.fecModes?.length) {
      obj.fecModes = message.fecModes;
    }
    if (message.ports?.length) {
      obj.ports = message.ports;
    }
    if (message.numPorts !== 0) {
      obj.numPorts = Math.round(message.numPorts);
    }
    if (message.speed !== "") {
      obj.speed = message.speed;
    }
    if (message.defaultPluggable !== "") {
      obj.defaultPluggable = message.defaultPluggable;
    }
    if (message.groupTypes?.length) {
      obj.groupTypes = message.groupTypes.map((e) => serverPortGroupTypeToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BreakoutMode>, I>>(base?: I): BreakoutMode {
    return BreakoutMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BreakoutMode>, I>>(object: I): BreakoutMode {
    const message = createBaseBreakoutMode();
    message.mode = object.mode ?? "";
    message.description = object.description ?? "";
    message.isDefault = object.isDefault ?? false;
    message.fecModes = object.fecModes?.map((e) => e) || [];
    message.ports = object.ports?.map((e) => e) || [];
    message.numPorts = object.numPorts ?? 0;
    message.speed = object.speed ?? "";
    message.defaultPluggable = object.defaultPluggable ?? "";
    message.groupTypes = object.groupTypes?.map((e) => e) || [];
    return message;
  },
};

function createBaseServerPortGroup(): ServerPortGroup {
  return {
    groupType: 0,
    portType: 0,
    numPortsPerSlot: 0,
    speed: "",
    slotNumbers: [],
    defaultPluggable: "",
    groupConnectionLimit: 0,
    portSetId: 0,
  };
}

export const ServerPortGroup: MessageFns<ServerPortGroup> = {
  encode(message: ServerPortGroup, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.groupType !== 0) {
      writer.uint32(8).int32(message.groupType);
    }
    if (message.portType !== 0) {
      writer.uint32(16).int32(message.portType);
    }
    if (message.numPortsPerSlot !== 0) {
      writer.uint32(24).uint32(message.numPortsPerSlot);
    }
    if (message.speed !== "") {
      writer.uint32(34).string(message.speed);
    }
    writer.uint32(42).fork();
    for (const v of message.slotNumbers) {
      writer.int32(v);
    }
    writer.join();
    if (message.defaultPluggable !== "") {
      writer.uint32(50).string(message.defaultPluggable);
    }
    if (message.groupConnectionLimit !== 0) {
      writer.uint32(56).uint32(message.groupConnectionLimit);
    }
    if (message.portSetId !== 0) {
      writer.uint32(64).uint32(message.portSetId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerPortGroup {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerPortGroup();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.groupType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.portType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.numPortsPerSlot = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.speed = reader.string();
          continue;
        }
        case 5: {
          if (tag === 40) {
            message.slotNumbers.push(reader.int32());

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.slotNumbers.push(reader.int32());
            }

            continue;
          }

          break;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.defaultPluggable = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.groupConnectionLimit = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.portSetId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerPortGroup {
    return {
      groupType: isSet(object.groupType) ? serverPortGroupTypeFromJSON(object.groupType) : 0,
      portType: isSet(object.portType) ? portTypeFromJSON(object.portType) : 0,
      numPortsPerSlot: isSet(object.numPortsPerSlot) ? globalThis.Number(object.numPortsPerSlot) : 0,
      speed: isSet(object.speed) ? globalThis.String(object.speed) : "",
      slotNumbers: globalThis.Array.isArray(object?.slotNumbers)
        ? object.slotNumbers.map((e: any) => globalThis.Number(e))
        : [],
      defaultPluggable: isSet(object.defaultPluggable) ? globalThis.String(object.defaultPluggable) : "",
      groupConnectionLimit: isSet(object.groupConnectionLimit) ? globalThis.Number(object.groupConnectionLimit) : 0,
      portSetId: isSet(object.portSetId) ? globalThis.Number(object.portSetId) : 0,
    };
  },

  toJSON(message: ServerPortGroup): unknown {
    const obj: any = {};
    if (message.groupType !== 0) {
      obj.groupType = serverPortGroupTypeToJSON(message.groupType);
    }
    if (message.portType !== 0) {
      obj.portType = portTypeToJSON(message.portType);
    }
    if (message.numPortsPerSlot !== 0) {
      obj.numPortsPerSlot = Math.round(message.numPortsPerSlot);
    }
    if (message.speed !== "") {
      obj.speed = message.speed;
    }
    if (message.slotNumbers?.length) {
      obj.slotNumbers = message.slotNumbers.map((e) => Math.round(e));
    }
    if (message.defaultPluggable !== "") {
      obj.defaultPluggable = message.defaultPluggable;
    }
    if (message.groupConnectionLimit !== 0) {
      obj.groupConnectionLimit = Math.round(message.groupConnectionLimit);
    }
    if (message.portSetId !== 0) {
      obj.portSetId = Math.round(message.portSetId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerPortGroup>, I>>(base?: I): ServerPortGroup {
    return ServerPortGroup.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerPortGroup>, I>>(object: I): ServerPortGroup {
    const message = createBaseServerPortGroup();
    message.groupType = object.groupType ?? 0;
    message.portType = object.portType ?? 0;
    message.numPortsPerSlot = object.numPortsPerSlot ?? 0;
    message.speed = object.speed ?? "";
    message.slotNumbers = object.slotNumbers?.map((e) => e) || [];
    message.defaultPluggable = object.defaultPluggable ?? "";
    message.groupConnectionLimit = object.groupConnectionLimit ?? 0;
    message.portSetId = object.portSetId ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
